import React, { useEffect, useState } from "react";
import { backend, categoryurl } from "../../../path";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../../App.css";
import styled from "styled-components";
import { GrFacebookOption } from "react-icons/gr";
import { LiaInstagram, LiaUserCircle } from "react-icons/lia";
import { AiFillYoutube } from "react-icons/ai";
import { RiTwitterXLine } from "react-icons/ri";
import { GoHome } from "react-icons/go";
import { MdOutlineCategory, MdOutlineManageHistory } from "react-icons/md";
import { PiShoppingCartThin } from "react-icons/pi";
import {
  IoCloseOutline,
  IoPersonOutline,
  IoSearchOutline,
} from "react-icons/io5";
import { CiHeart, CiLogin } from "react-icons/ci";

import { RxDashboard, RxHamburgerMenu } from "react-icons/rx";
import { BsChevronDown } from "react-icons/bs";
import LogInOut from "../../components/icons/LogInOut";
import CartOwn from "../../components/icons/CartOwn";
import Login from "../../pages/registration/login";
import Registration from "../../pages/registration/registration";

function HeaderMainNew(props) {
  const navigate = useNavigate();
  const [subcategory, setSubcategory] = useState(false);
  const [subcategoryItems, setSubcategoryItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [data, setData] = useState([]);
  const [name, setName] = useState([]);
  const [products, setProducts] = useState([]);
  const [cartData, setCartData] = useState([]);
  const [wish, setWish] = useState([]);
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [search, setSearch] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [isMobileHeaderActive, setMobileHeaderActive] = useState(false);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [isCategoriesVisible, setCategoriesVisible] = useState(false);
  const [openLoginDropdown, setOpenLoginDropdown] = useState(false);
  const [openSearch, setOpenSearch] = useState();
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );
  const location = useLocation();
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    window.openAuthModal = (mode = "login") => {
      setIsLogin(mode === "login");
      const dlg = document.getElementById("dialog");
      if (dlg && typeof dlg.showModal === "function") {
        dlg.showModal();
      }
    };
    return () => {
      if (window.openAuthModal) {
        delete window.openAuthModal;
      }
    };
  }, []);

  // Function to toggle the visibility of the mobile header
  const toggleMobileHeader = () => {
    setMobileHeaderActive(!isMobileHeaderActive);
  };

  useEffect(() => {
    setMobileHeaderActive(false);
    setOpenLoginDropdown(false);
    setCategoriesVisible(false);
  }, [location]);

  useEffect(() => {
    if (!openLoginDropdown) return;

    const handleDocumentClick = (event) => {
      if (!event.target.closest("[data-login-dropdown]")) {
        setOpenLoginDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, [openLoginDropdown]);
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  const fetchData = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getcategorywithsubcategory", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchProducts = () => {
    setLoading(true);

    fetch(backend + "getallproductsfrontend", {
      method: "GET",
    })
      .then((response) => {
        if (response.status === 302) {
          const redirectUrl = response.headers.get("Location");
          console.error(`Redirecting to: ${redirectUrl}`);
          throw new Error(`Redirection to ${redirectUrl}`);
        }
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setProducts(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    fetchProducts();
  }, [selectedCategory]);

  const handleSubCategory = (id) => {
    const selectedCategory = data.find((item) => item.category_id === id);
    if (selectedCategory) {
      setSubcategoryItems(selectedCategory.subcategory || []);
    }
    setSubcategory(true);
    setSelectedCategory(id);
  };

  const handleSubCategoryRoute = (subCategoryId) => {
    // sessionStorage.setItem("subCategoryId", subCategoryId);
    toggleDropdown();
    props?.SearchFetch();
    navigate(`/subcategory/${subCategoryId}`);
    // window.location.reload();
  };

  const handleCategoryMain = (cat) => {
    // sessionStorage.setItem("categoryId", cat);
    // setSubcategory(false)
    props?.SearchFetch();
    navigate(`/category/${cat}`);
    // window.location.reload();
  };

  useEffect(() => {
    if (authenticated) {
      fetchDataCart();
      fetchDataWish();
    }
  }, [authenticated, props.cartChange, props.wishChange]);

  const fetchDataCart = () => {
    setLoading(true);

    fetch(backend + `getcartbyuseriduserside`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCartData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchDataWish = () => {
    setLoading(true);

    fetch(backend + `getwishlistbyuseriduserside`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setWish(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchName = () => {
    setLoading(true);

    const url = authenticated?.usertype === 1 ? "getusername" : "getadminname";

    fetch(backend + url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setName(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (authenticated) {
      fetchName();
    }
  }, [authenticated]);

  const [openCategory, setOpenCategory] = useState(null);

  // Function to handle category click
  const handleCategoryClick = (categoryId) => {
    // Toggle the category: if already open, close it; if closed, open it
    setOpenCategory(openCategory === categoryId ? null : categoryId);
  };

  const getOptions = (inputValue) => {
    setSearch(inputValue);
    if (inputValue.trim() === "") {
      setFilteredOptions([]);
      return;
    }

    // Filter products based on input value
    const filtered = products.filter((product) =>
      product.product_name.toLowerCase().includes(inputValue.toLowerCase())
    );
    setFilteredOptions(filtered.slice(0, 18));
  };
  const handleSelectSearch = (inputValue) => {
    props.setSearch(inputValue);
    setFilteredOptions([]);
  };

  const handleProductRoute = (productId) => {
    setSearch("");
    props.setSearch("");
    setFilteredOptions([]);
    navigate(`/product/${productId}`);
  };
  const handleOpenLoginDropDown = () => {
    setOpenLoginDropdown(!openLoginDropdown);
  };
  const handleOpenCategory = () => {
    setCategoriesVisible(!isCategoriesVisible);
  };
  return (
    <>
      {authenticated?.usertype === 1 ? (
        <>
          <Header>
            <Main>
              <div className="wrapper">
                <Container>
                  <Link to="/">
                    <ImageContainer>
                      <img src="/storage/general/ks-logo32.png" />
                    </ImageContainer>
                  </Link>
                  <Nav>
                    <NavInner>
                      <Link to="/deals">Today's Deal's</Link>
                      <Link to="/popular">Popular Product's</Link>
                      <Link to="/top-selling">Top Selling</Link>
                    </NavInner>
                    <SearchContainer>
                      {/* <IoSearchOutline
                        style={{ fontSize: "30px", color: "#200E32" }}
                      /> */}
                      <img
                        src="/storage/general/Vector.svg"
                        alt="search-icon"
                      />
                      <Input
                        type="text"
                        id="search"
                        className="px-2"
                        placeholder="Search"
                        // value={props.search}
                        value={search}
                        onChange={(e) => getOptions(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSelectSearch(search);
                          }
                        }} // onChange={(e) => props.setSearch(e.target.value)}
                        autocomplete="off"
                      />
                      {filteredOptions.length > 0 && (
                        <SearchSuggestions>
                          {filteredOptions.map((option, index) => (
                            <Suggestion
                              key={index}
                              onClick={() =>
                                handleProductRoute(option?.product_slug)
                              }
                            >
                              {option.product_name}
                            </Suggestion>
                          ))}
                        </SearchSuggestions>
                      )}
                    </SearchContainer>
                  </Nav>
                  <Section className="top-btns">
                    <Buttons>
                      {/* <Button className="notification-style">
                        {wish && wish.length > 0 ? (
                          <Number>{wish.length}</Number>
                        ) : null}
                        <div>
                          <span>
                            <CiHeart />
                          </span>
                          <Link to={authenticated ? "/wishlist" : "/login"}>
                            Wishlist
                          </Link>
                        </div>
                      </Button> */}
                      <Button className="notification-style">
                        {cartData && cartData.length > 0 ? (
                          <Number>{cartData.length}</Number>
                        ) : null}
                        <div>
                            <Link
                              to={authenticated ? "/cart" : "#"}
                              onClick={(e) => { if (!authenticated) { e.preventDefault(); setIsLogin(true); const dlg = document.getElementById("dialog"); if (dlg && typeof dlg.showModal === "function") { dlg.showModal(); } } }}
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                marginLeft: "5px",
                                fontFamily: "Inter, sans-serif",
                              }}
                            >
                          <div className="d-flex justify-content-between w-100">
                            

                          
                              <CartOwn />
                              Cart
                          </div>
                        </Link>
                        </div>
                      </Button>
                      {authenticated ? (
                        <Button
                          className="user"
                          onClick={handleOpenLoginDropDown}
                          data-login-dropdown="true"
                        >
                          <span>
                            <IoPersonOutline />
                          </span>
                          <div>
                            <div
                              // to="#"
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                marginLeft: "5px",
                                fontFamily: "Inter, sans-serif",
                              }}
                            // onClick={()=>handleOpenLoginDropDown}
                            >
                              {" "}
                              {authenticated && `${name}`}
                            </div>
                          </div>
                        </Button>
                      ) : (
                        <Button
                          onClick={handleOpenLoginDropDown}
                          className=" d-flex items-center gap-1"
                          data-login-dropdown="true"
                        // style={{fontSize:'18px', fontWeight:'500'}}
                        >
                          {/* <CiLogin />  */}
                          <LogInOut />
                          <div class="font-Inter font-bold text-lg leading-none tracking-normal text-black">
                            Login/Signup
                          </div>
                        </Button>
                      )}

                      {authenticated ? (
                        <LogoutModal open={openLoginDropdown} data-login-dropdown="true">
                          <div className="flex flex-col space-y-4 p-4 border border-bg-[rgba(200, 200, 200, 1)] bg-white rounded-[21px] shadow-md font-JostSans">
                            <Link
                              to="/myorders"
                              onClick={() => props?.SearchFetch()}
                            >
                              <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full gap-2">
                               <MdOutlineManageHistory size={20} />
                                My Orders
                              </button>
                            </Link>
                            <Link to="/wishlist">
                              <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full gap-2">
                                <CiHeart size={20} />
                                Wishlist
                              </button>
                            </Link>
                            <div onClick={handleLogout}>
                              <Link to="/" onClick={() => props?.SearchFetch()}>
                                <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                                  <svg
                                    className="w-5 h-5 mr-2"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                                      clipRule="evenodd"
                                    ></path>
                                  </svg>
                                  Logout
                                </button>
                              </Link>
                            </div>
                          </div>
                        </LogoutModal>
                      ) : (
                        <LogoutModal open={openLoginDropdown} data-login-dropdown="true">
                          <div className="flex flex-col space-y-4 pe-3 ps-2 py-3 bg-white border border-bg-[rgba(200, 200, 200, 1)] rounded-[21px] shadow-md font-JostSans">
                            {/* <Link
                              to="/login"
                              onClick={() => props?.SearchFetch()}
                            > */}
                            <button
                              command="show-modal"
                              commandfor="dialog"
                              onClick={() => setIsLogin(true)}
                              className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="15"
                                viewBox="0 0 12 15"
                                fill="none"
                                className="mr-4 mt-1"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M5.25 0C4.65326 0 4.08097 0.237053 3.65901 0.65901C3.23705 1.08097 3 1.65326 3 2.25V12.75C3 13.3467 3.23705 13.919 3.65901 14.341C4.08097 14.7629 4.65326 15 5.25 15H9.75C10.3467 15 10.919 14.7629 11.341 14.341C11.7629 13.919 12 13.3467 12 12.75V2.25C12 1.65326 11.7629 1.08097 11.341 0.65901C10.919 0.237053 10.3467 0 9.75 0H5.25ZM6.21975 4.71975C6.3604 4.57915 6.55113 4.50016 6.75 4.50016C6.94887 4.50016 7.1396 4.57915 7.28025 4.71975L9.53025 6.96975C9.67085 7.1104 9.74984 7.30113 9.74984 7.5C9.74984 7.69887 9.67085 7.8896 9.53025 8.03025L7.28025 10.2802C7.1388 10.4169 6.94935 10.4925 6.7527 10.4908C6.55605 10.489 6.36794 10.4102 6.22889 10.2711C6.08983 10.1321 6.01095 9.94395 6.00924 9.7473C6.00754 9.55065 6.08313 9.3612 6.21975 9.21975L7.1895 8.25H0.75C0.551088 8.25 0.360322 8.17098 0.21967 8.03033C0.0790178 7.88968 0 7.69891 0 7.5C0 7.30109 0.0790178 7.11032 0.21967 6.96967C0.360322 6.82902 0.551088 6.75 0.75 6.75H7.1895L6.21975 5.78025C6.07915 5.6396 6.00016 5.44887 6.00016 5.25C6.00016 5.05113 6.07915 4.8604 6.21975 4.71975Z"
                                  fill="black"
                                />
                              </svg>
                              Login
                            </button>
                            {/* </Link> */}
                            <button
                              command="show-modal"
                              commandfor="dialog"
                              onClick={() => setIsLogin(false)}
                              className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="13"
                                height="15"
                                viewBox="0 0 13 15"
                                fill="none"
                                className="mr-4 mt-1"
                              >
                                <path
                                  d="M11.4051 1.22204C11.206 1.02276 10.9695 0.864685 10.7091 0.756857C10.4488 0.649029 10.1698 0.593562 9.88808 0.593628C9.60633 0.593694 9.32735 0.649291 9.0671 0.75724C8.80684 0.86519 8.57042 1.02337 8.37134 1.22275L1.63721 7.96609C1.23596 8.36826 1.01053 8.91311 1.01034 9.48121L1.01034 11.75C1.01034 12.0433 1.24834 12.2813 1.54159 12.2813H3.82454C4.39334 12.2813 4.93875 12.0546 5.34038 11.653L12.0695 4.91955C12.4709 4.51719 12.6964 3.97205 12.6964 3.40371C12.6964 2.83537 12.4709 2.29023 12.0695 1.88788L11.4051 1.22204ZM0.833252 13.3438C0.692356 13.3438 0.55723 13.3997 0.457601 13.4994C0.357973 13.599 0.302002 13.7341 0.302002 13.875C0.302002 14.0159 0.357973 14.151 0.457601 14.2507C0.55723 14.3503 0.692356 14.4063 0.833252 14.4063H12.1666C12.3075 14.4063 12.4426 14.3503 12.5422 14.2507C12.6419 14.151 12.6978 14.0159 12.6978 13.875C12.6978 13.7341 12.6419 13.599 12.5422 13.4994C12.4426 13.3997 12.3075 13.3438 12.1666 13.3438H0.833252Z"
                                  fill="#1D1B20"
                                />
                              </svg>
                              Register
                            </button>
                          </div>
                        </LogoutModal>
                      )}
                    </Buttons>
                  </Section>
                </Container>
              </div>
            </Main>
            <ItemContainer>
              <Items>
                {data.map((item, i) => (
                  <Item
                    // style={{
                    //   backgroundColor:
                    //     selectedCategory === item.category_id && subcategory
                    //       ? "#e1f0da"
                    //       : "transparent",
                    // }}
                    key={i}
                    onMouseEnter={() => handleSubCategory(item.category_id)}
                    // onClick={() => setSubcategory(false)}
                    onClick={() => {
                      handleCategoryMain(item.category_slug);
                    }}
                  >
                    <ItemDiv>
                      <Link
                        to=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#000",
                          fontSize: "15px",
                        }}
                      >
                        <div>
                          <img
                            src={categoryurl + item.logo}
                            width={30}
                            height={30}
                          />{" "}
                        </div>
                        <div>{item.category_name}</div>
                      </Link>
                      <Arrow>
                        <BsChevronDown />
                      </Arrow>
                    </ItemDiv>
                    {subcategory && (
                      <Dropdown className="ml-3">
                        {subcategoryItems.length > 0 ? (
                          subcategoryItems.map((subItem, index) => (
                            <li key={index}>
                              <div
                                // to={`/subcategory/${subItem.sub_category_id}`}
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent bubbling to parent
                                  handleSubCategoryRoute(
                                    subItem.sub_category_slug
                                  );
                                }}
                              // to={"/product-list"}
                              >
                                {subItem.sub_category_name}
                              </div>
                            </li>
                          ))
                        ) : (
                          <ul className="ml-3">
                            <li>coming soon</li>
                          </ul>
                        )}
                      </Dropdown>
                    )}
                  </Item>
                ))}
              </Items>
            </ItemContainer>
          </Header>
          {/* mobile container */}
          <MobileHeader>
            <svg
              onClick={toggleMobileHeader}
              width="24"
              height="16"
              viewBox="0 0 24 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 16V13.3333H24V16H0ZM0 9.33333V6.66667H24V9.33333H0ZM0 2.66667V0H24V2.66667H0Z"
                fill="#62BC00"
              />
            </svg>

            <Link to="/">
              <ImageContainer>
                <img src="/storage/general/ks-logo32.png" />
              </ImageContainer>
            </Link>
            <div className="d-flex justify-content-end w-100">
              {authenticated ? (
                <Button className="user" onClick={handleOpenLoginDropDown} data-login-dropdown="true">
                  <span>
                    <IoPersonOutline />
                  </span>
                  <div>
                    <div>
                      {" "}
                      {authenticated && `${name}`}
                    </div>
                  </div>
                </Button>
              ) : (
                <Button
                  onClick={handleOpenLoginDropDown}
                  className=" d-flex items-center gap-1"
                  data-login-dropdown="true"
                // style={{fontSize:'18px', fontWeight:'500'}}
                >
                  <svg
                    width="73"
                    height="12"
                    viewBox="0 0 73 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.936 0.599999H2.352V7.728H5.688V9H0.936V0.599999ZM6.18534 6.24C6.18534 5.672 6.31334 5.172 6.56934 4.74C6.83334 4.308 7.18934 3.972 7.63734 3.732C8.08534 3.484 8.59334 3.36 9.16134 3.36C9.72934 3.36 10.2333 3.484 10.6733 3.732C11.1213 3.972 11.4773 4.308 11.7413 4.74C12.0053 5.172 12.1373 5.672 12.1373 6.24C12.1373 6.8 12.0053 7.3 11.7413 7.74C11.4773 8.172 11.1213 8.512 10.6733 8.76C10.2333 9 9.72934 9.12 9.16134 9.12C8.59334 9.12 8.08534 9 7.63734 8.76C7.18934 8.512 6.83334 8.172 6.56934 7.74C6.31334 7.3 6.18534 6.8 6.18534 6.24ZM7.51734 6.24C7.51734 6.584 7.58934 6.888 7.73334 7.152C7.87734 7.408 8.07334 7.612 8.32134 7.764C8.56934 7.908 8.84934 7.98 9.16134 7.98C9.46534 7.98 9.74134 7.908 9.98934 7.764C10.2453 7.612 10.4453 7.408 10.5893 7.152C10.7333 6.888 10.8053 6.584 10.8053 6.24C10.8053 5.896 10.7333 5.592 10.5893 5.328C10.4453 5.064 10.2453 4.86 9.98934 4.716C9.74134 4.572 9.46534 4.5 9.16134 4.5C8.84934 4.5 8.56934 4.572 8.32134 4.716C8.07334 4.86 7.87734 5.064 7.73334 5.328C7.58934 5.592 7.51734 5.896 7.51734 6.24ZM13.0551 9.372H14.3391C14.3471 9.62 14.4151 9.844 14.5431 10.044C14.6791 10.244 14.8631 10.4 15.0951 10.512C15.3271 10.624 15.5951 10.68 15.8991 10.68C16.1711 10.68 16.4311 10.616 16.6791 10.488C16.9271 10.36 17.1271 10.164 17.2791 9.9C17.4391 9.636 17.5191 9.296 17.5191 8.88V3.48H18.7911V8.88C18.7911 9.544 18.6551 10.092 18.3831 10.524C18.1191 10.956 17.7711 11.276 17.3391 11.484C16.9071 11.7 16.4391 11.808 15.9351 11.808C15.3351 11.808 14.8231 11.704 14.3991 11.496C13.9751 11.296 13.6471 11.012 13.4151 10.644C13.1911 10.276 13.0711 9.852 13.0551 9.372ZM12.9471 6.216C12.9471 5.6 13.0711 5.084 13.3191 4.668C13.5671 4.244 13.8951 3.92 14.3031 3.696C14.7191 3.472 15.1631 3.36 15.6351 3.36C16.0991 3.36 16.5031 3.476 16.8471 3.708C17.1991 3.932 17.4751 4.256 17.6751 4.68C17.8831 5.104 17.9871 5.616 17.9871 6.216C17.9871 6.808 17.8831 7.316 17.6751 7.74C17.4751 8.164 17.1991 8.492 16.8471 8.724C16.5031 8.948 16.0991 9.06 15.6351 9.06C15.1631 9.06 14.7191 8.948 14.3031 8.724C13.8951 8.5 13.5671 8.176 13.3191 7.752C13.0711 7.328 12.9471 6.816 12.9471 6.216ZM14.2911 6.216C14.2911 6.584 14.3671 6.896 14.5191 7.152C14.6711 7.408 14.8711 7.604 15.1191 7.74C15.3751 7.868 15.6511 7.932 15.9471 7.932C16.1951 7.932 16.4391 7.868 16.6791 7.74C16.9271 7.612 17.1271 7.42 17.2791 7.164C17.4391 6.9 17.5191 6.584 17.5191 6.216C17.5191 5.928 17.4711 5.68 17.3751 5.472C17.2871 5.256 17.1671 5.076 17.0151 4.932C16.8631 4.78 16.6911 4.668 16.4991 4.596C16.3151 4.524 16.1311 4.488 15.9471 4.488C15.6511 4.488 15.3751 4.556 15.1191 4.692C14.8711 4.82 14.6711 5.012 14.5191 5.268C14.3671 5.524 14.2911 5.84 14.2911 6.216ZM20.3503 1.284C20.3503 1.06 20.4303 0.872 20.5903 0.719999C20.7583 0.567999 20.9503 0.491999 21.1663 0.491999C21.3983 0.491999 21.5903 0.567999 21.7423 0.719999C21.9023 0.872 21.9823 1.06 21.9823 1.284C21.9823 1.5 21.9023 1.688 21.7423 1.848C21.5903 2 21.3983 2.076 21.1663 2.076C20.9503 2.076 20.7583 2 20.5903 1.848C20.4303 1.688 20.3503 1.5 20.3503 1.284ZM20.5303 3.48H21.8023V9H20.5303V3.48ZM27.1378 5.64C27.1378 5.232 27.0538 4.924 26.8858 4.716C26.7178 4.508 26.4578 4.404 26.1058 4.404C25.8658 4.404 25.6538 4.456 25.4698 4.56C25.2858 4.656 25.1418 4.8 25.0378 4.992C24.9338 5.176 24.8818 5.392 24.8818 5.64V9H23.5858V3.48H24.8818V4.332C25.0578 4.004 25.2818 3.76 25.5538 3.6C25.8338 3.44 26.1658 3.36 26.5498 3.36C27.1738 3.36 27.6498 3.552 27.9778 3.936C28.3058 4.312 28.4698 4.832 28.4698 5.496V9H27.1378V5.64ZM34.4689 0.599999H35.7409L30.7849 10.8H29.4769L34.4689 0.599999ZM37.406 6.3C37.59 6.62 37.786 6.904 37.994 7.152C38.21 7.392 38.446 7.58 38.702 7.716C38.958 7.844 39.246 7.908 39.566 7.908C39.95 7.908 40.262 7.804 40.502 7.596C40.742 7.388 40.862 7.12 40.862 6.792C40.862 6.48 40.786 6.232 40.634 6.048C40.482 5.856 40.27 5.696 39.998 5.568C39.734 5.432 39.426 5.3 39.074 5.172C38.866 5.1 38.634 5.004 38.378 4.884C38.122 4.756 37.878 4.6 37.646 4.416C37.414 4.224 37.222 3.992 37.07 3.72C36.918 3.44 36.842 3.104 36.842 2.712C36.842 2.264 36.958 1.872 37.19 1.536C37.422 1.192 37.734 0.928 38.126 0.744C38.526 0.552 38.978 0.456 39.482 0.456C39.978 0.456 40.41 0.544 40.778 0.719999C41.146 0.895999 41.454 1.12 41.702 1.392C41.958 1.664 42.158 1.948 42.302 2.244L41.15 2.892C41.046 2.684 40.914 2.492 40.754 2.316C40.594 2.132 40.406 1.988 40.19 1.884C39.982 1.772 39.738 1.716 39.458 1.716C39.066 1.716 38.778 1.808 38.594 1.992C38.41 2.168 38.318 2.376 38.318 2.616C38.318 2.832 38.382 3.028 38.51 3.204C38.646 3.372 38.854 3.532 39.134 3.684C39.414 3.836 39.778 3.992 40.226 4.152C40.474 4.24 40.722 4.352 40.97 4.488C41.226 4.624 41.458 4.796 41.666 5.004C41.874 5.204 42.038 5.44 42.158 5.712C42.286 5.984 42.35 6.304 42.35 6.672C42.35 7.064 42.274 7.416 42.122 7.728C41.97 8.04 41.762 8.304 41.498 8.52C41.234 8.728 40.934 8.888 40.598 9C40.27 9.12 39.926 9.18 39.566 9.18C39.07 9.18 38.61 9.084 38.186 8.892C37.77 8.692 37.406 8.428 37.094 8.1C36.782 7.772 36.534 7.416 36.35 7.032L37.406 6.3ZM43.6472 1.284C43.6472 1.06 43.7272 0.872 43.8872 0.719999C44.0552 0.567999 44.2472 0.491999 44.4632 0.491999C44.6952 0.491999 44.8872 0.567999 45.0392 0.719999C45.1992 0.872 45.2792 1.06 45.2792 1.284C45.2792 1.5 45.1992 1.688 45.0392 1.848C44.8872 2 44.6952 2.076 44.4632 2.076C44.2472 2.076 44.0552 2 43.8872 1.848C43.7272 1.688 43.6472 1.5 43.6472 1.284ZM43.8272 3.48H45.0992V9H43.8272V3.48ZM46.5707 9.372H47.8547C47.8627 9.62 47.9307 9.844 48.0587 10.044C48.1947 10.244 48.3787 10.4 48.6107 10.512C48.8427 10.624 49.1107 10.68 49.4147 10.68C49.6867 10.68 49.9467 10.616 50.1947 10.488C50.4427 10.36 50.6427 10.164 50.7947 9.9C50.9547 9.636 51.0347 9.296 51.0347 8.88V3.48H52.3067V8.88C52.3067 9.544 52.1707 10.092 51.8987 10.524C51.6347 10.956 51.2867 11.276 50.8547 11.484C50.4227 11.7 49.9547 11.808 49.4507 11.808C48.8507 11.808 48.3387 11.704 47.9147 11.496C47.4907 11.296 47.1627 11.012 46.9307 10.644C46.7067 10.276 46.5867 9.852 46.5707 9.372ZM46.4627 6.216C46.4627 5.6 46.5867 5.084 46.8347 4.668C47.0827 4.244 47.4107 3.92 47.8187 3.696C48.2347 3.472 48.6787 3.36 49.1507 3.36C49.6147 3.36 50.0187 3.476 50.3627 3.708C50.7147 3.932 50.9907 4.256 51.1907 4.68C51.3987 5.104 51.5027 5.616 51.5027 6.216C51.5027 6.808 51.3987 7.316 51.1907 7.74C50.9907 8.164 50.7147 8.492 50.3627 8.724C50.0187 8.948 49.6147 9.06 49.1507 9.06C48.6787 9.06 48.2347 8.948 47.8187 8.724C47.4107 8.5 47.0827 8.176 46.8347 7.752C46.5867 7.328 46.4627 6.816 46.4627 6.216ZM47.8067 6.216C47.8067 6.584 47.8827 6.896 48.0347 7.152C48.1867 7.408 48.3867 7.604 48.6347 7.74C48.8907 7.868 49.1667 7.932 49.4627 7.932C49.7107 7.932 49.9547 7.868 50.1947 7.74C50.4427 7.612 50.6427 7.42 50.7947 7.164C50.9547 6.9 51.0347 6.584 51.0347 6.216C51.0347 5.928 50.9867 5.68 50.8907 5.472C50.8027 5.256 50.6827 5.076 50.5307 4.932C50.3787 4.78 50.2067 4.668 50.0147 4.596C49.8307 4.524 49.6467 4.488 49.4627 4.488C49.1667 4.488 48.8907 4.556 48.6347 4.692C48.3867 4.82 48.1867 5.012 48.0347 5.268C47.8827 5.524 47.8067 5.84 47.8067 6.216ZM57.4659 5.64C57.4659 5.232 57.3819 4.924 57.2139 4.716C57.0459 4.508 56.7859 4.404 56.4339 4.404C56.1939 4.404 55.9819 4.456 55.7979 4.56C55.6139 4.656 55.4699 4.8 55.3659 4.992C55.2619 5.176 55.2099 5.392 55.2099 5.64V9H53.9139V3.48H55.2099V4.332C55.3859 4.004 55.6099 3.76 55.8819 3.6C56.1619 3.44 56.4939 3.36 56.8779 3.36C57.5019 3.36 57.9779 3.552 58.3059 3.936C58.6339 4.312 58.7979 4.832 58.7979 5.496V9H57.4659V5.64ZM61.785 6.84C61.785 7.232 61.869 7.536 62.037 7.752C62.205 7.968 62.461 8.076 62.805 8.076C63.053 8.076 63.269 8.028 63.453 7.932C63.637 7.828 63.781 7.684 63.885 7.5C63.989 7.308 64.041 7.088 64.041 6.84V3.48H65.337V9H64.041V8.148C63.865 8.468 63.637 8.712 63.357 8.88C63.085 9.04 62.757 9.12 62.373 9.12C61.757 9.12 61.281 8.928 60.945 8.544C60.617 8.16 60.453 7.64 60.453 6.984V3.48H61.785V6.84ZM68.2521 11.64H66.9441V3.48H68.2521V11.64ZM72.8241 6.24C72.8241 6.848 72.7001 7.372 72.4521 7.812C72.2041 8.244 71.8761 8.576 71.4681 8.808C71.0601 9.032 70.6161 9.144 70.1361 9.144C69.6641 9.144 69.2521 9.028 68.9001 8.796C68.5561 8.556 68.2881 8.22 68.0961 7.788C67.9121 7.348 67.8201 6.832 67.8201 6.24C67.8201 5.64 67.9121 5.124 68.0961 4.692C68.2881 4.26 68.5561 3.928 68.9001 3.696C69.2521 3.456 69.6641 3.336 70.1361 3.336C70.6161 3.336 71.0601 3.452 71.4681 3.684C71.8761 3.908 72.2041 4.236 72.4521 4.668C72.7001 5.1 72.8241 5.624 72.8241 6.24ZM71.4801 6.24C71.4801 5.872 71.4041 5.56 71.2521 5.304C71.1001 5.04 70.8961 4.844 70.6401 4.716C70.3921 4.58 70.1161 4.512 69.8121 4.512C69.5641 4.512 69.3201 4.58 69.0801 4.716C68.8401 4.844 68.6401 5.036 68.4801 5.292C68.3281 5.548 68.2521 5.864 68.2521 6.24C68.2521 6.616 68.3281 6.932 68.4801 7.188C68.6401 7.444 68.8401 7.64 69.0801 7.776C69.3201 7.904 69.5641 7.968 69.8121 7.968C70.1161 7.968 70.3921 7.904 70.6401 7.776C70.8961 7.64 71.1001 7.444 71.2521 7.188C71.4041 6.924 71.4801 6.608 71.4801 6.24Z"
                      fill="#222222"
                    />
                  </svg>
                </Button>
              )}
            </div>
            {authenticated ? (
              <LogoutModalMobileSec open={openLoginDropdown} data-login-dropdown="true">
                <div className="flex flex-col space-y-4 p-4 border border-bg-[rgba(200, 200, 200, 1)] bg-white rounded-[21px] shadow-md font-JostSans">
                  <Link to="/myorders" onClick={() => props?.SearchFetch()}>
                    <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                      <svg
                        className="w-5 h-5 mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      My Orders
                    </button>
                  </Link>
                  <div onClick={handleLogout}>
                    <Link to="/" onClick={() => props?.SearchFetch()}>
                      <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                        <svg
                          className="w-5 h-5 mr-2"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                        Logout
                      </button>
                    </Link>
                  </div>
                </div>
              </LogoutModalMobileSec>
            ) : (
              <LogoutModalMobileSec open={openLoginDropdown} data-login-dropdown="true">
                <div className="flex flex-col space-y-4 pe-3 ps-2 py-3 bg-white border border-bg-[rgba(200, 200, 200, 1)] rounded-[21px] shadow-md font-JostSans">
                  {/* <Link
                              to="/login"
                              onClick={() => props?.SearchFetch()}
                            > */}
                  <button
                    command="show-modal"
                    commandfor="dialog"
                    onClick={() => setIsLogin(true)}
                    className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="15"
                      viewBox="0 0 12 15"
                      fill="none"
                      className="mr-4 mt-1"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.25 0C4.65326 0 4.08097 0.237053 3.65901 0.65901C3.23705 1.08097 3 1.65326 3 2.25V12.75C3 13.3467 3.23705 13.919 3.65901 14.341C4.08097 14.7629 4.65326 15 5.25 15H9.75C10.3467 15 10.919 14.7629 11.341 14.341C11.7629 13.919 12 13.3467 12 12.75V2.25C12 1.65326 11.7629 1.08097 11.341 0.65901C10.919 0.237053 10.3467 0 9.75 0H5.25ZM6.21975 4.71975C6.3604 4.57915 6.55113 4.50016 6.75 4.50016C6.94887 4.50016 7.1396 4.57915 7.28025 4.71975L9.53025 6.96975C9.67085 7.1104 9.74984 7.30113 9.74984 7.5C9.74984 7.69887 9.67085 7.8896 9.53025 8.03025L7.28025 10.2802C7.1388 10.4169 6.94935 10.4925 6.7527 10.4908C6.55605 10.489 6.36794 10.4102 6.22889 10.2711C6.08983 10.1321 6.01095 9.94395 6.00924 9.7473C6.00754 9.55065 6.08313 9.3612 6.21975 9.21975L7.1895 8.25H0.75C0.551088 8.25 0.360322 8.17098 0.21967 8.03033C0.0790178 7.88968 0 7.69891 0 7.5C0 7.30109 0.0790178 7.11032 0.21967 6.96967C0.360322 6.82902 0.551088 6.75 0.75 6.75H7.1895L6.21975 5.78025C6.07915 5.6396 6.00016 5.44887 6.00016 5.25C6.00016 5.05113 6.07915 4.8604 6.21975 4.71975Z"
                        fill="black"
                      />
                    </svg>
                    Login
                  </button>
                  {/* </Link> */}
                  <button
                    command="show-modal"
                    commandfor="dialog"
                    onClick={() => setIsLogin(false)}
                    className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="15"
                      viewBox="0 0 13 15"
                      fill="none"
                      className="mr-4 mt-1"
                    >
                      <path
                        d="M11.4051 1.22204C11.206 1.02276 10.9695 0.864685 10.7091 0.756857C10.4488 0.649029 10.1698 0.593562 9.88808 0.593628C9.60633 0.593694 9.32735 0.649291 9.0671 0.75724C8.80684 0.86519 8.57042 1.02337 8.37134 1.22275L1.63721 7.96609C1.23596 8.36826 1.01053 8.91311 1.01034 9.48121L1.01034 11.75C1.01034 12.0433 1.24834 12.2813 1.54159 12.2813H3.82454C4.39334 12.2813 4.93875 12.0546 5.34038 11.653L12.0695 4.91955C12.4709 4.51719 12.6964 3.97205 12.6964 3.40371C12.6964 2.83537 12.4709 2.29023 12.0695 1.88788L11.4051 1.22204ZM0.833252 13.3438C0.692356 13.3438 0.55723 13.3997 0.457601 13.4994C0.357973 13.599 0.302002 13.7341 0.302002 13.875C0.302002 14.0159 0.357973 14.151 0.457601 14.2507C0.55723 14.3503 0.692356 14.4063 0.833252 14.4063H12.1666C12.3075 14.4063 12.4426 14.3503 12.5422 14.2507C12.6419 14.151 12.6978 14.0159 12.6978 13.875C12.6978 13.7341 12.6419 13.599 12.5422 13.4994C12.4426 13.3997 12.3075 13.3438 12.1666 13.3438H0.833252Z"
                        fill="#1D1B20"
                      />
                    </svg>
                    Register
                  </button>
                </div>
              </LogoutModalMobileSec>
            )}
          </MobileHeader>
          <MobileHeaderSearch>
            <SearchContainerOld className="">
              <Input
                // className="mobile-search px-2"
                type="text"
                placeholder="Search"
                // value={props.search}
                value={search}
                onChange={(e) => getOptions(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSelectSearch(search);
                  }
                }} // onChange={(e) => props.setSearch(e.target.value)}
                autocomplete="off"
              />
              {/* <IoSearchOutline /> */}
              <img src="/storage/general/Vector.svg" alt="search-icon" />
              {filteredOptions.length > 0 && (
                <SearchSuggestions className="mobile">
                  {filteredOptions.map((option, index) => (
                    <Suggestion
                      key={index}
                      onClick={() => handleProductRoute(option?.product_slug)}
                    >
                      {option.product_name}
                    </Suggestion>
                  ))}
                </SearchSuggestions>
              )}
            </SearchContainerOld>
          </MobileHeaderSearch>
          <Slider className={isMobileHeaderActive ? "active" : ""}>
            <MobileTop>
              <Link to="/">
                <ImageContainer>
                  <img src="/storage/general/ks-logo32.png" />
                </ImageContainer>
              </Link>
              <div onClick={toggleMobileHeader}>
                <IoCloseOutline />
              </div>
            </MobileTop>
            <Socials className="mobile">
              <a
                target="_blank"
                href="https://www.facebook.com/myKeralaspecial?mibextid=qi2Omg&rdid=kccxW9NpVX3BFzrU&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FXM1oRDDkvagcQKW9%2F%3Fmibextid%3Dqi2Omg"
              >
                <GrFacebookOption />
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/keralaspecial/"
              >
                <LiaInstagram />
              </a>
              <a
                target="_blank"
                href="https://www.youtube.com/@keralaspecial5256"
              >
                <AiFillYoutube />
              </a>
              <a
                target="_blank"
                href="https://x.com/mykeralaspecial?t=5jaIdWgLfUhVzxywcQto9g"
              >
                <RiTwitterXLine />
              </a>
            </Socials>
            <Buttons className="mobile">
              {!authenticated ? (
                <div className="">
                  {/* <Link to="/login" onClick={() => props?.SearchFetch()}>
                    {" "}
                    <button className="">LOGIN</button>
                  </Link>
                  <Link to="/register">
                    <button className="">REGISTER</button>
                  </Link> */}
                </div>
              ) : (
                <>
                  <div className="">
                    <Link to="/myorders" onClick={() => props?.SearchFetch()}>
                      {" "}
                      <button className="">MY ORDERS</button>
                    </Link>
                  </div>
                  <div className="" onClick={handleLogout}>
                    <Link to="/" onClick={() => props?.SearchFetch()}>
                      {" "}
                      <button className="">LOGOUT</button>
                    </Link>
                  </div>
                </>
              )}
              {/* <LoginBtn>
                <Link to="/login">Login</Link>
              </LoginBtn>
              <LoginBtn>
                <Link to="/register">Register</Link>
              </LoginBtn> */}
            </Buttons>
            <Nav className="mobile">
              <Link to="/">Home</Link>
              <Link to="/about-us">About Us</Link>
              <Link to="/blog">Blogs</Link>
              <Link to="/contact-us">Contact Us</Link>
            </Nav>
            <P>Copyright</P>
          </Slider>
          <MobileHeaderBottom>
            <Buttons className="bottom">
              <Link to={"/"} className="flex items-center gap-1">
                <svg
                  width="30"
                  height="45"
                  viewBox="0 0 30 45"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 11.0859V25.75C3 27.5449 4.45507 29 6.25 29C8.04493 29 9.5 27.5449 9.5 25.75V21.2982C9.5 19.0891 11.2909 17.2982 13.5 17.2982H16.5C18.7091 17.2982 20.5 19.0891 20.5 21.2982V25.75C20.5 27.5449 21.9551 29 23.75 29C25.5449 29 27 27.5449 27 25.75V11.186C27 9.91118 26.3923 8.71271 25.364 7.9593L16.9652 1.80607C15.5098 0.73981 13.5208 0.779807 12.1094 1.90372L4.50821 7.95685C3.5552 8.71577 3 9.86763 3 11.0859Z"
                    fill="#187837"
                  />
                  LOGIN
                  <path
                    d="M6.14 34.03V41H5.23V37.84H1.68V41H0.77V34.03H1.68V37.09H5.23V34.03H6.14ZM10.0838 41.09C9.57049 41.09 9.10383 40.9733 8.68383 40.74C8.27049 40.5067 7.94383 40.1767 7.70383 39.75C7.47049 39.3167 7.35383 38.8167 7.35383 38.25C7.35383 37.69 7.47383 37.1967 7.71383 36.77C7.96049 36.3367 8.29383 36.0067 8.71383 35.78C9.13383 35.5467 9.60383 35.43 10.1238 35.43C10.6438 35.43 11.1138 35.5467 11.5338 35.78C11.9538 36.0067 12.2838 36.3333 12.5238 36.76C12.7705 37.1867 12.8938 37.6833 12.8938 38.25C12.8938 38.8167 12.7672 39.3167 12.5138 39.75C12.2672 40.1767 11.9305 40.5067 11.5038 40.74C11.0772 40.9733 10.6038 41.09 10.0838 41.09ZM10.0838 40.29C10.4105 40.29 10.7172 40.2133 11.0038 40.06C11.2905 39.9067 11.5205 39.6767 11.6938 39.37C11.8738 39.0633 11.9638 38.69 11.9638 38.25C11.9638 37.81 11.8772 37.4367 11.7038 37.13C11.5305 36.8233 11.3038 36.5967 11.0238 36.45C10.7438 36.2967 10.4405 36.22 10.1138 36.22C9.78049 36.22 9.47383 36.2967 9.19383 36.45C8.92049 36.5967 8.70049 36.8233 8.53383 37.13C8.36716 37.4367 8.28383 37.81 8.28383 38.25C8.28383 38.6967 8.36383 39.0733 8.52383 39.38C8.69049 39.6867 8.91049 39.9167 9.18383 40.07C9.45716 40.2167 9.75716 40.29 10.0838 40.29ZM20.6803 35.42C21.107 35.42 21.487 35.51 21.8203 35.69C22.1536 35.8633 22.417 36.1267 22.6103 36.48C22.8036 36.8333 22.9003 37.2633 22.9003 37.77V41H22.0003V37.9C22.0003 37.3533 21.8636 36.9367 21.5903 36.65C21.3236 36.3567 20.9603 36.21 20.5003 36.21C20.027 36.21 19.6503 36.3633 19.3703 36.67C19.0903 36.97 18.9503 37.4067 18.9503 37.98V41H18.0503V37.9C18.0503 37.3533 17.9136 36.9367 17.6403 36.65C17.3736 36.3567 17.0103 36.21 16.5503 36.21C16.077 36.21 15.7003 36.3633 15.4203 36.67C15.1403 36.97 15.0003 37.4067 15.0003 37.98V41H14.0903V35.52H15.0003V36.31C15.1803 36.0233 15.4203 35.8033 15.7203 35.65C16.027 35.4967 16.3636 35.42 16.7303 35.42C17.1903 35.42 17.597 35.5233 17.9503 35.73C18.3036 35.9367 18.567 36.24 18.7403 36.64C18.8936 36.2533 19.147 35.9533 19.5003 35.74C19.8536 35.5267 20.247 35.42 20.6803 35.42ZM29.393 38.05C29.393 38.2233 29.383 38.4067 29.363 38.6H24.983C25.0164 39.14 25.1997 39.5633 25.533 39.87C25.873 40.17 26.283 40.32 26.763 40.32C27.1564 40.32 27.483 40.23 27.743 40.05C28.0097 39.8633 28.1964 39.6167 28.303 39.31H29.283C29.1364 39.8367 28.843 40.2667 28.403 40.6C27.963 40.9267 27.4164 41.09 26.763 41.09C26.243 41.09 25.7764 40.9733 25.363 40.74C24.9564 40.5067 24.6364 40.1767 24.403 39.75C24.1697 39.3167 24.053 38.8167 24.053 38.25C24.053 37.6833 24.1664 37.1867 24.393 36.76C24.6197 36.3333 24.9364 36.0067 25.343 35.78C25.7564 35.5467 26.2297 35.43 26.763 35.43C27.283 35.43 27.743 35.5433 28.143 35.77C28.543 35.9967 28.8497 36.31 29.063 36.71C29.283 37.1033 29.393 37.55 29.393 38.05ZM28.453 37.86C28.453 37.5133 28.3764 37.2167 28.223 36.97C28.0697 36.7167 27.8597 36.5267 27.593 36.4C27.333 36.2667 27.043 36.2 26.723 36.2C26.263 36.2 25.8697 36.3467 25.543 36.64C25.223 36.9333 25.0397 37.34 24.993 37.86H28.453Z"
                    fill="black"
                  />
                </svg>
              </Link>
              <Button
                onClick={handleOpenCategory}
                className="mobile flex items-center gap-1"
              >
                <svg
                  width="57"
                  height="44"
                  viewBox="0 0 57 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M39.376 5.88257C40.2354 3.48379 37.834 1.20743 35.4846 2.19368L19.2391 9.01313C16.6495 10.1002 16.926 13.8557 19.6468 14.5519L23.0274 15.4169C24.4711 15.7863 25.6671 16.7948 26.2749 18.1555L28.1316 22.3124C29.2082 24.7228 32.6734 24.5909 33.5638 22.1057L39.376 5.88257ZM34.7287 0.393054C38.6445 -1.2507 42.6467 2.54325 41.2144 6.54121L35.4022 22.7644C33.9183 26.9064 28.1429 27.1261 26.3486 23.1089L24.4918 18.952C24.1271 18.1355 23.4096 17.5304 22.5433 17.3088L19.1627 16.4438C14.628 15.2835 14.1673 9.02425 18.4833 7.21251L34.7287 0.393054Z"
                    fill="black"
                  />
                  <path
                    d="M0.93 36.51C0.93 35.83 1.08333 35.22 1.39 34.68C1.69667 34.1333 2.11333 33.7067 2.64 33.4C3.17333 33.0933 3.76333 32.94 4.41 32.94C5.17 32.94 5.83333 33.1233 6.4 33.49C6.96667 33.8567 7.38 34.3767 7.64 35.05H6.55C6.35667 34.63 6.07667 34.3067 5.71 34.08C5.35 33.8533 4.91667 33.74 4.41 33.74C3.92333 33.74 3.48667 33.8533 3.1 34.08C2.71333 34.3067 2.41 34.63 2.19 35.05C1.97 35.4633 1.86 35.95 1.86 36.51C1.86 37.0633 1.97 37.55 2.19 37.97C2.41 38.3833 2.71333 38.7033 3.1 38.93C3.48667 39.1567 3.92333 39.27 4.41 39.27C4.91667 39.27 5.35 39.16 5.71 38.94C6.07667 38.7133 6.35667 38.39 6.55 37.97H7.64C7.38 38.6367 6.96667 39.1533 6.4 39.52C5.83333 39.88 5.17 40.06 4.41 40.06C3.76333 40.06 3.17333 39.91 2.64 39.61C2.11333 39.3033 1.69667 38.88 1.39 38.34C1.08333 37.8 0.93 37.19 0.93 36.51ZM8.65461 37.24C8.65461 36.68 8.76794 36.19 8.99461 35.77C9.22128 35.3433 9.53128 35.0133 9.92461 34.78C10.3246 34.5467 10.7679 34.43 11.2546 34.43C11.7346 34.43 12.1513 34.5333 12.5046 34.74C12.8579 34.9467 13.1213 35.2067 13.2946 35.52V34.52H14.2146V40H13.2946V38.98C13.1146 39.3 12.8446 39.5667 12.4846 39.78C12.1313 39.9867 11.7179 40.09 11.2446 40.09C10.7579 40.09 10.3179 39.97 9.92461 39.73C9.53128 39.49 9.22128 39.1533 8.99461 38.72C8.76794 38.2867 8.65461 37.7933 8.65461 37.24ZM13.2946 37.25C13.2946 36.8367 13.2113 36.4767 13.0446 36.17C12.8779 35.8633 12.6513 35.63 12.3646 35.47C12.0846 35.3033 11.7746 35.22 11.4346 35.22C11.0946 35.22 10.7846 35.3 10.5046 35.46C10.2246 35.62 10.0013 35.8533 9.83461 36.16C9.66794 36.4667 9.58461 36.8267 9.58461 37.24C9.58461 37.66 9.66794 38.0267 9.83461 38.34C10.0013 38.6467 10.2246 38.8833 10.5046 39.05C10.7846 39.21 11.0946 39.29 11.4346 39.29C11.7746 39.29 12.0846 39.21 12.3646 39.05C12.6513 38.8833 12.8779 38.6467 13.0446 38.34C13.2113 38.0267 13.2946 37.6633 13.2946 37.25ZM16.8624 35.27V38.5C16.8624 38.7667 16.9191 38.9567 17.0324 39.07C17.1458 39.1767 17.3424 39.23 17.6224 39.23H18.2924V40H17.4724C16.9658 40 16.5858 39.8833 16.3324 39.65C16.0791 39.4167 15.9524 39.0333 15.9524 38.5V35.27H15.2424V34.52H15.9524V33.14H16.8624V34.52H18.2924V35.27H16.8624ZM24.395 37.05C24.395 37.2233 24.385 37.4067 24.365 37.6H19.985C20.0183 38.14 20.2017 38.5633 20.535 38.87C20.875 39.17 21.285 39.32 21.765 39.32C22.1583 39.32 22.485 39.23 22.745 39.05C23.0117 38.8633 23.1983 38.6167 23.305 38.31H24.285C24.1383 38.8367 23.845 39.2667 23.405 39.6C22.965 39.9267 22.4183 40.09 21.765 40.09C21.245 40.09 20.7783 39.9733 20.365 39.74C19.9583 39.5067 19.6383 39.1767 19.405 38.75C19.1717 38.3167 19.055 37.8167 19.055 37.25C19.055 36.6833 19.1683 36.1867 19.395 35.76C19.6217 35.3333 19.9383 35.0067 20.345 34.78C20.7583 34.5467 21.2317 34.43 21.765 34.43C22.285 34.43 22.745 34.5433 23.145 34.77C23.545 34.9967 23.8517 35.31 24.065 35.71C24.285 36.1033 24.395 36.55 24.395 37.05ZM23.455 36.86C23.455 36.5133 23.3783 36.2167 23.225 35.97C23.0717 35.7167 22.8617 35.5267 22.595 35.4C22.335 35.2667 22.045 35.2 21.725 35.2C21.265 35.2 20.8717 35.3467 20.545 35.64C20.225 35.9333 20.0417 36.34 19.995 36.86H23.455ZM27.8562 34.43C28.3295 34.43 28.7428 34.5333 29.0962 34.74C29.4562 34.9467 29.7228 35.2067 29.8962 35.52V34.52H30.8162V40.12C30.8162 40.62 30.7095 41.0633 30.4962 41.45C30.2828 41.8433 29.9762 42.15 29.5762 42.37C29.1828 42.59 28.7228 42.7 28.1962 42.7C27.4762 42.7 26.8762 42.53 26.3962 42.19C25.9162 41.85 25.6328 41.3867 25.5462 40.8H26.4462C26.5462 41.1333 26.7528 41.4 27.0662 41.6C27.3795 41.8067 27.7562 41.91 28.1962 41.91C28.6962 41.91 29.1028 41.7533 29.4162 41.44C29.7362 41.1267 29.8962 40.6867 29.8962 40.12V38.97C29.7162 39.29 29.4495 39.5567 29.0962 39.77C28.7428 39.9833 28.3295 40.09 27.8562 40.09C27.3695 40.09 26.9262 39.97 26.5262 39.73C26.1328 39.49 25.8228 39.1533 25.5962 38.72C25.3695 38.2867 25.2562 37.7933 25.2562 37.24C25.2562 36.68 25.3695 36.19 25.5962 35.77C25.8228 35.3433 26.1328 35.0133 26.5262 34.78C26.9262 34.5467 27.3695 34.43 27.8562 34.43ZM29.8962 37.25C29.8962 36.8367 29.8128 36.4767 29.6462 36.17C29.4795 35.8633 29.2528 35.63 28.9662 35.47C28.6862 35.3033 28.3762 35.22 28.0362 35.22C27.6962 35.22 27.3862 35.3 27.1062 35.46C26.8262 35.62 26.6028 35.8533 26.4362 36.16C26.2695 36.4667 26.1862 36.8267 26.1862 37.24C26.1862 37.66 26.2695 38.0267 26.4362 38.34C26.6028 38.6467 26.8262 38.8833 27.1062 39.05C27.3862 39.21 27.6962 39.29 28.0362 39.29C28.3762 39.29 28.6862 39.21 28.9662 39.05C29.2528 38.8833 29.4795 38.6467 29.6462 38.34C29.8128 38.0267 29.8962 37.6633 29.8962 37.25ZM34.744 40.09C34.2307 40.09 33.764 39.9733 33.344 39.74C32.9307 39.5067 32.604 39.1767 32.364 38.75C32.1307 38.3167 32.014 37.8167 32.014 37.25C32.014 36.69 32.134 36.1967 32.374 35.77C32.6207 35.3367 32.954 35.0067 33.374 34.78C33.794 34.5467 34.264 34.43 34.784 34.43C35.304 34.43 35.774 34.5467 36.194 34.78C36.614 35.0067 36.944 35.3333 37.184 35.76C37.4307 36.1867 37.554 36.6833 37.554 37.25C37.554 37.8167 37.4273 38.3167 37.174 38.75C36.9273 39.1767 36.5907 39.5067 36.164 39.74C35.7373 39.9733 35.264 40.09 34.744 40.09ZM34.744 39.29C35.0707 39.29 35.3773 39.2133 35.664 39.06C35.9507 38.9067 36.1807 38.6767 36.354 38.37C36.534 38.0633 36.624 37.69 36.624 37.25C36.624 36.81 36.5373 36.4367 36.364 36.13C36.1907 35.8233 35.964 35.5967 35.684 35.45C35.404 35.2967 35.1007 35.22 34.774 35.22C34.4407 35.22 34.134 35.2967 33.854 35.45C33.5807 35.5967 33.3607 35.8233 33.194 36.13C33.0273 36.4367 32.944 36.81 32.944 37.25C32.944 37.6967 33.024 38.0733 33.184 38.38C33.3507 38.6867 33.5707 38.9167 33.844 39.07C34.1173 39.2167 34.4173 39.29 34.744 39.29ZM39.6605 35.41C39.8205 35.0967 40.0471 34.8533 40.3405 34.68C40.6405 34.5067 41.0038 34.42 41.4305 34.42V35.36H41.1905C40.1705 35.36 39.6605 35.9133 39.6605 37.02V40H38.7505V34.52H39.6605V35.41ZM42.9509 33.63C42.7776 33.63 42.6309 33.57 42.5109 33.45C42.3909 33.33 42.3309 33.1833 42.3309 33.01C42.3309 32.8367 42.3909 32.69 42.5109 32.57C42.6309 32.45 42.7776 32.39 42.9509 32.39C43.1176 32.39 43.2576 32.45 43.3709 32.57C43.4909 32.69 43.5509 32.8367 43.5509 33.01C43.5509 33.1833 43.4909 33.33 43.3709 33.45C43.2576 33.57 43.1176 33.63 42.9509 33.63ZM43.3909 34.52V40H42.4809V34.52H43.3909ZM49.9419 37.05C49.9419 37.2233 49.9319 37.4067 49.9119 37.6H45.5319C45.5652 38.14 45.7485 38.5633 46.0819 38.87C46.4219 39.17 46.8319 39.32 47.3119 39.32C47.7052 39.32 48.0319 39.23 48.2919 39.05C48.5585 38.8633 48.7452 38.6167 48.8519 38.31H49.8319C49.6852 38.8367 49.3919 39.2667 48.9519 39.6C48.5119 39.9267 47.9652 40.09 47.3119 40.09C46.7919 40.09 46.3252 39.9733 45.9119 39.74C45.5052 39.5067 45.1852 39.1767 44.9519 38.75C44.7185 38.3167 44.6019 37.8167 44.6019 37.25C44.6019 36.6833 44.7152 36.1867 44.9419 35.76C45.1685 35.3333 45.4852 35.0067 45.8919 34.78C46.3052 34.5467 46.7785 34.43 47.3119 34.43C47.8319 34.43 48.2919 34.5433 48.6919 34.77C49.0919 34.9967 49.3985 35.31 49.6119 35.71C49.8319 36.1033 49.9419 36.55 49.9419 37.05ZM49.0019 36.86C49.0019 36.5133 48.9252 36.2167 48.7719 35.97C48.6185 35.7167 48.4085 35.5267 48.1419 35.4C47.8819 35.2667 47.5919 35.2 47.2719 35.2C46.8119 35.2 46.4185 35.3467 46.0919 35.64C45.7719 35.9333 45.5885 36.34 45.5419 36.86H49.0019ZM53.083 40.09C52.663 40.09 52.2864 40.02 51.953 39.88C51.6197 39.7333 51.3564 39.5333 51.163 39.28C50.9697 39.02 50.863 38.7233 50.843 38.39H51.783C51.8097 38.6633 51.9364 38.8867 52.163 39.06C52.3964 39.2333 52.6997 39.32 53.073 39.32C53.4197 39.32 53.693 39.2433 53.893 39.09C54.093 38.9367 54.193 38.7433 54.193 38.51C54.193 38.27 54.0864 38.0933 53.873 37.98C53.6597 37.86 53.3297 37.7433 52.883 37.63C52.4764 37.5233 52.143 37.4167 51.883 37.31C51.6297 37.1967 51.4097 37.0333 51.223 36.82C51.043 36.6 50.953 36.3133 50.953 35.96C50.953 35.68 51.0364 35.4233 51.203 35.19C51.3697 34.9567 51.6064 34.7733 51.913 34.64C52.2197 34.5 52.5697 34.43 52.963 34.43C53.5697 34.43 54.0597 34.5833 54.433 34.89C54.8064 35.1967 55.0064 35.6167 55.033 36.15H54.123C54.103 35.8633 53.9864 35.6333 53.773 35.46C53.5664 35.2867 53.2864 35.2 52.933 35.2C52.6064 35.2 52.3464 35.27 52.153 35.41C51.9597 35.55 51.863 35.7333 51.863 35.96C51.863 36.14 51.9197 36.29 52.033 36.41C52.153 36.5233 52.2997 36.6167 52.473 36.69C52.653 36.7567 52.8997 36.8333 53.213 36.92C53.6064 37.0267 53.9264 37.1333 54.173 37.24C54.4197 37.34 54.6297 37.4933 54.803 37.7C54.983 37.9067 55.0764 38.1767 55.083 38.51C55.083 38.81 54.9997 39.08 54.833 39.32C54.6664 39.56 54.4297 39.75 54.123 39.89C53.823 40.0233 53.4764 40.09 53.083 40.09Z"
                    fill="black"
                  />
                </svg>
              </Button>
              <Button className="mobile">
                {/* <Number className="mobile">{wish?.length}</Number> */}
                <Link to={authenticated ? "/wishlist" : "#"} onClick={(e) => { if (!authenticated) { e.preventDefault(); setIsLogin(true); const dlg = document.getElementById("dialog"); if (dlg && typeof dlg.showModal === "function") { dlg.showModal(); } } }}>
                  <CiHeart size={36} />{/* make sure font-poppins class exists (see config below) */}
                  <div className="text-[10px] font-poppins font-normal leading-[100%] tracking-[0%] text-[#000]">
                    Wishlist
                  </div>

                </Link>
              </Button>
              <Button className="mobile">
                <Number className="mobile">{cartData?.length}</Number>
                <Link to={authenticated ? "/cart" : "/login"}>
                  <span>
                    <svg
                      width="29"
                      height="41"
                      viewBox="0 0 29 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.0161 3C1.74661 3 1.48816 3.10705 1.29761 3.29761C1.10705 3.48816 1 3.74661 1 4.0161C1 4.28558 1.10705 4.54403 1.29761 4.73459C1.48816 4.92514 1.74661 5.0322 2.0161 5.0322H2.51602C2.73666 5.03258 2.95118 5.10477 3.12716 5.23785C3.30314 5.37094 3.43102 5.55769 3.49147 5.76988L6.71454 17.0486C6.89683 17.6851 7.2814 18.2449 7.8101 18.6435C8.3388 19.042 8.98288 19.2576 9.64497 19.2576H18.9301C19.5394 19.2577 20.1348 19.0752 20.6394 18.7336C21.144 18.392 21.5347 17.907 21.7609 17.3412L24.7564 9.85054C24.8795 9.5423 24.9253 9.2086 24.8897 8.8786C24.8541 8.54859 24.7382 8.23233 24.5521 7.95746C24.3661 7.68259 24.1155 7.45747 23.8224 7.30179C23.5292 7.14611 23.2024 7.0646 22.8705 7.06439H5.97482L5.44441 5.21103C5.26258 4.57449 4.87848 4.01444 4.35016 3.61555C3.82184 3.21665 3.17802 3.00058 2.51602 3H2.0161ZM8.66951 16.4877L6.55603 9.09659H22.8705L19.873 16.5873C19.7975 16.7756 19.6674 16.9371 19.4993 17.0508C19.3313 17.1645 19.133 17.2253 18.9301 17.2254H9.64497C9.42433 17.225 9.20981 17.1528 9.03383 17.0197C8.85785 16.8866 8.72997 16.6999 8.66951 16.4877ZM10.1449 27.3864C10.5452 27.3864 10.9416 27.3075 11.3114 27.1543C11.6813 27.0011 12.0173 26.7766 12.3004 26.4935C12.5834 26.2105 12.808 25.8744 12.9611 25.5046C13.1143 25.1348 13.1932 24.7384 13.1932 24.3381C13.1932 23.9378 13.1143 23.5414 12.9611 23.1715C12.808 22.8017 12.5834 22.4657 12.3004 22.1826C12.0173 21.8995 11.6813 21.675 11.3114 21.5218C10.9416 21.3686 10.5452 21.2898 10.1449 21.2898C9.33643 21.2898 8.56108 21.6109 7.98941 22.1826C7.41775 22.7543 7.09659 23.5296 7.09659 24.3381C7.09659 25.1465 7.41775 25.9219 7.98941 26.4935C8.56108 27.0652 9.33643 27.3864 10.1449 27.3864ZM10.1449 25.3542C9.8754 25.3542 9.61695 25.2471 9.4264 25.0566C9.23584 24.866 9.12879 24.6076 9.12879 24.3381C9.12879 24.0686 9.23584 23.8101 9.4264 23.6196C9.61695 23.429 9.8754 23.322 10.1449 23.322C10.4144 23.322 10.6728 23.429 10.8634 23.6196C11.0539 23.8101 11.161 24.0686 11.161 24.3381C11.161 24.6076 11.0539 24.866 10.8634 25.0566C10.6728 25.2471 10.4144 25.3542 10.1449 25.3542ZM18.2737 27.3864C18.674 27.3864 19.0704 27.3075 19.4402 27.1543C19.81 27.0011 20.1461 26.7766 20.4291 26.4935C20.7122 26.2105 20.9367 25.8744 21.0899 25.5046C21.2431 25.1348 21.322 24.7384 21.322 24.3381C21.322 23.9378 21.2431 23.5414 21.0899 23.1715C20.9367 22.8017 20.7122 22.4657 20.4291 22.1826C20.1461 21.8995 19.81 21.675 19.4402 21.5218C19.0704 21.3686 18.674 21.2898 18.2737 21.2898C17.4652 21.2898 16.6899 21.6109 16.1182 22.1826C15.5465 22.7543 15.2254 23.5296 15.2254 24.3381C15.2254 25.1465 15.5465 25.9219 16.1182 26.4935C16.6899 27.0652 17.4652 27.3864 18.2737 27.3864ZM18.2737 25.3542C18.0042 25.3542 17.7457 25.2471 17.5552 25.0566C17.3646 24.866 17.2576 24.6076 17.2576 24.3381C17.2576 24.0686 17.3646 23.8101 17.5552 23.6196C17.7457 23.429 18.0042 23.322 18.2737 23.322C18.5432 23.322 18.8016 23.429 18.9922 23.6196C19.1827 23.8101 19.2898 24.0686 19.2898 24.3381C19.2898 24.6076 19.1827 24.866 18.9922 25.0566C18.8016 25.2471 18.5432 25.3542 18.2737 25.3542Z"
                        fill="black"
                      />
                      <path
                        d="M3.93 36.51C3.93 35.83 4.08333 35.22 4.39 34.68C4.69667 34.1333 5.11333 33.7067 5.64 33.4C6.17333 33.0933 6.76333 32.94 7.41 32.94C8.17 32.94 8.83333 33.1233 9.4 33.49C9.96667 33.8567 10.38 34.3767 10.64 35.05H9.55C9.35667 34.63 9.07667 34.3067 8.71 34.08C8.35 33.8533 7.91667 33.74 7.41 33.74C6.92333 33.74 6.48667 33.8533 6.1 34.08C5.71333 34.3067 5.41 34.63 5.19 35.05C4.97 35.4633 4.86 35.95 4.86 36.51C4.86 37.0633 4.97 37.55 5.19 37.97C5.41 38.3833 5.71333 38.7033 6.1 38.93C6.48667 39.1567 6.92333 39.27 7.41 39.27C7.91667 39.27 8.35 39.16 8.71 38.94C9.07667 38.7133 9.35667 38.39 9.55 37.97H10.64C10.38 38.6367 9.96667 39.1533 9.4 39.52C8.83333 39.88 8.17 40.06 7.41 40.06C6.76333 40.06 6.17333 39.91 5.64 39.61C5.11333 39.3033 4.69667 38.88 4.39 38.34C4.08333 37.8 3.93 37.19 3.93 36.51ZM11.6546 37.24C11.6546 36.68 11.7679 36.19 11.9946 35.77C12.2213 35.3433 12.5313 35.0133 12.9246 34.78C13.3246 34.5467 13.7679 34.43 14.2546 34.43C14.7346 34.43 15.1513 34.5333 15.5046 34.74C15.8579 34.9467 16.1213 35.2067 16.2946 35.52V34.52H17.2146V40H16.2946V38.98C16.1146 39.3 15.8446 39.5667 15.4846 39.78C15.1313 39.9867 14.7179 40.09 14.2446 40.09C13.7579 40.09 13.3179 39.97 12.9246 39.73C12.5313 39.49 12.2213 39.1533 11.9946 38.72C11.7679 38.2867 11.6546 37.7933 11.6546 37.24ZM16.2946 37.25C16.2946 36.8367 16.2113 36.4767 16.0446 36.17C15.8779 35.8633 15.6513 35.63 15.3646 35.47C15.0846 35.3033 14.7746 35.22 14.4346 35.22C14.0946 35.22 13.7846 35.3 13.5046 35.46C13.2246 35.62 13.0013 35.8533 12.8346 36.16C12.6679 36.4667 12.5846 36.8267 12.5846 37.24C12.5846 37.66 12.6679 38.0267 12.8346 38.34C13.0013 38.6467 13.2246 38.8833 13.5046 39.05C13.7846 39.21 14.0946 39.29 14.4346 39.29C14.7746 39.29 15.0846 39.21 15.3646 39.05C15.6513 38.8833 15.8779 38.6467 16.0446 38.34C16.2113 38.0267 16.2946 37.6633 16.2946 37.25ZM19.6624 35.41C19.8224 35.0967 20.0491 34.8533 20.3424 34.68C20.6424 34.5067 21.0058 34.42 21.4324 34.42V35.36H21.1924C20.1724 35.36 19.6624 35.9133 19.6624 37.02V40H18.7524V34.52H19.6624V35.41ZM23.5929 35.27V38.5C23.5929 38.7667 23.6496 38.9567 23.7629 39.07C23.8762 39.1767 24.0729 39.23 24.3529 39.23H25.0229V40H24.2029C23.6962 40 23.3162 39.8833 23.0629 39.65C22.8096 39.4167 22.6829 39.0333 22.6829 38.5V35.27H21.9729V34.52H22.6829V33.14H23.5929V34.52H25.0229V35.27H23.5929Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </Link>
              </Button>

              <CategoriesModal className={isCategoriesVisible ? "active" : ""}>
                <Items className="mobile">
                  {data.slice(0, -1).map((item, i) => (
                    <Item
                      // style={{
                      //   backgroundColor:
                      //     selectedCategory === item.category_id && subcategory
                      //       ? "#e1f0da"
                      //       : "transparent",
                      // }}
                      key={i}
                      // onMouseEnter={() => handleSubCategory(item.category_id)}
                      // onClick={() => setSubcategory(false)}
                      onClick={() => {
                        handleCategoryMain(item.category_slug);
                      }}
                    >
                      <ItemDiv>
                        <>
                          <div>
                            <img
                              src={categoryurl + item.logo}
                              width={30}
                              height={30}
                            />{" "}
                          </div>
                          <div>{item.category_name}</div>
                        </>
                        {/* <Arrow>
                          <BsChevronDown />
                        </Arrow> */}
                      </ItemDiv>
                    </Item>
                  ))}
                </Items>
              </CategoriesModal>
            </Buttons>
          </MobileHeaderBottom>
          <MobileHeaderBottomBackground></MobileHeaderBottomBackground>
        </>
      ) : authenticated?.usertype === 0 ? (
        <div className="header-middle header-middle-ptb-1 d-none d-lg-block fixed-top bg-light">
          <div className="container">
            <div className="header-wrap">
              <Link to="/" style={{ padding: "10px 0" }}>
                <ImageContainer>
                  <img src="/storage/general/ks-logo32.png" />
                </ImageContainer>
              </Link>

              <div className="d-flex justify-content-end w-100">
                <div className="header-action-right">
                  <div className="header-action-2">
                    {/* <div className="header-action-icon-2">
                            <Link to="/onamgift">
                              <span className="lable">
                                <button
                                  type="button"
                                  className="hover-up"
                                  style={{
                                    backgroundColor: '#3bb77e',
                                    color: '#fff',
                                    borderRadius: '5px',
                                    border: '1px solid',
                                    height: '36px',
                                    width: '100px',
                                    bottom: '5px',
                                    animation: 'blink 1s infinite'
                                  }}                          >
                                  ONAM GIFTS
                                </button></span>
                            </Link>
                          </div> */}
                    {/* <div className="header-action-icon-2">
                      <Link to="/wishlist">
                        <img
                          className="svgInject"
                          alt="Wishlist"
                          src="/themes/nest/imgs/theme/icons/icon-heart.svg"
                        />
                        <span className="pro-count blue wishlist-count">
                          {wish?.length}
                        </span>
                      </Link>
                      <Link to="/wishlist">
                        <span className="lable">Wishlist</span>
                      </Link>
                    </div>
                    <div className="header-action-icon-2">
                      <Link className="mini-cart-icon" to="/cart">
                        <img
                          alt="Cart"
                          src="/themes/nest/imgs/theme/icons/icon-cart.svg"
                        />
                        <span className="pro-count blue">
                          {cartData?.length}
                        </span>
                      </Link>
                      <Link to="/cart">
                        <span className="lable">Cart</span>
                      </Link>
                      {cartData?.length < 1 && (
                        <div className="cart-dropdown-wrap cart-dropdown-hm2 cart-dropdown-panel">
                          <span>No products in the cart.</span>
                        </div>
                      )}
                    </div> */}
                    <div className="header-action-icon-2">
                      <Link>
                        <img
                          className="svgInject rounded-circle"
                          alt="Account"
                          src="/themes/nest/imgs/theme/icons/icon-user.svg"
                        />
                      </Link>
                      <Link to="/" onClick={() => props?.SearchFetch()}>
                        <span className="lable me-1">
                          {authenticated ? `${name}` : "Account"}
                        </span>
                      </Link>
                      <div className="cart-dropdown-wrap cart-dropdown-hm2 account-dropdown">
                        <ul>
                          {!authenticated ? (
                            <>
                              <div className="btn-wrap">
                                <Link
                                  to="/login"
                                  onClick={() => props?.SearchFetch()}
                                >
                                  {" "}
                                  <button className="login-btn">LOGIN</button>
                                </Link>
                                <Link to="/register">
                                  <button className="login-btn">
                                    REGISTER
                                  </button>
                                </Link>
                              </div>
                            </>
                          ) : (
                            <div className="btn-wrap" onClick={handleLogout}>
                              <Link to="/" onClick={() => props?.SearchFetch()}>
                                {" "}
                                <button className="login-btn">LOGOUT</button>
                              </Link>
                            </div>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : authenticated?.usertype === null ? (
        <div className="header-middle header-middle-ptb-1 d-none d-lg-block fixed-top bg-light">
          <div className="container">
            <div className="header-wrap">
              <div className="logo logo-width-1">
                <Link to="/" onClick={() => props?.SearchFetch()}>
                  <img
                    src="/storage/general/ks-logo32.png"
                    alt="Kerala Specials-Logo"
                  />
                </Link>
              </div>
              <div className="d-flex justify-content-end w-100">
                <div className="header-action-right">
                  <div className="header-action-2">
                    {/* <div className="header-action-icon-2">
                            <Link to="/onamgift">
                              <span className="lable">
                                <button
                                  type="button"
                                  className="hover-up"
                                  style={{
                                    backgroundColor: '#3bb77e',
                                    color: '#fff',
                                    borderRadius: '5px',
                                    border: '1px solid',
                                    height: '36px',
                                    width: '100px',
                                    bottom: '5px',
                                    animation: 'blink 1s infinite'
                                  }}                          >
                                  ONAM GIFTS
                                </button></span>
                            </Link>
                          </div> */}
                    {/* <div className="header-action-icon-2">
                      <Link to="/wishlist">
                        <img
                          className="svgInject"
                          alt="Wishlist"
                          src="/themes/nest/imgs/theme/icons/icon-heart.svg"
                        />
                        <span className="pro-count blue wishlist-count">
                          0{" "}
                        </span>
                      </Link>
                      <Link to="/wishlist">
                        <span className="lable">Wishlist</span>
                      </Link>
                    </div> */}
                    <div className="header-action-icon-2">
                      <Link className="mini-cart-icon" to="/cart">
                        <img
                          alt="Cart"
                          src="/themes/nest/imgs/theme/icons/icon-cart.svg"
                        />
                        <span className="pro-count blue">
                          {cartData?.length}
                        </span>
                      </Link>
                      <Link to="/cart">
                        <span className="lable">Cart</span>
                      </Link>
                      {cartData?.length < 1 && (
                        <div className="cart-dropdown-wrap cart-dropdown-hm2 cart-dropdown-panel">
                          <span>No products in the cart.</span>
                        </div>
                      )}
                    </div>
                    <div className="header-action-icon-2">
                      <div
                        onClick={() => setIsLogin(true)}
                        style={{ cursor: 'pointer' }}
                      >
                        <img
                          className="svgInject rounded-circle"
                          alt="Account"
                          src="/themes/nest/imgs/theme/icons/icon-user.svg"
                        />
                      </div>
                      <Link to="/" onClick={() => props?.SearchFetch()}>
                        <span className="lable me-1">
                          {authenticated ? `${name}` : <CiLogin />}
                        </span>
                      </Link>
                      <div className="cart-dropdown-wrap cart-dropdown-hm2 account-dropdown">
                        <ul>
                          {!authenticated ? (
                            <>
                              <div className="btn-wrap">
                                <Link
                                  to="/login"
                                  onClick={() => props?.SearchFetch()}
                                >
                                  {" "}
                                  <button className="login-btn">LOGIN</button>
                                </Link>
                                <Link to="/register">
                                  <button className="login-btn">
                                    REGISTER
                                  </button>
                                </Link>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="btn-wrap" onClick={handleLogout}>
                                <Link
                                  to="/"
                                  onClick={() => props?.SearchFetch()}
                                >
                                  {" "}
                                  <button className="login-btn">LOGOUT</button>
                                </Link>
                              </div>
                            </>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <Header>
            {/* <Top>
              <Left>
                <Socials>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/myKeralaspecial?mibextid=qi2Omg&rdid=kccxW9NpVX3BFzrU&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FXM1oRDDkvagcQKW9%2F%3Fmibextid%3Dqi2Omg"
                  >
                    <GrFacebookOption />
                  </a>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/keralaspecial/"
                  >
                    <LiaInstagram />
                  </a>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/@keralaspecial5256"
                  >
                    <AiFillYoutube />
                  </a>
                  <a
                    target="_blank"
                    href="https://x.com/mykeralaspecial?t=5jaIdWgLfUhVzxywcQto9g"
                  >
                    <RiTwitterXLine />
                  </a>
                </Socials>
              </Left>
              <Right>
                <a href="tel:+917356629493">+ 91 735 6629 493</a>
              </Right>
            </Top> */}
            <Main>
              <div className="wrapper">
                <Container>
                  <Link to="/">
                    <ImageContainer>
                      <img src="/storage/general/ks-logo32.png" />
                    </ImageContainer>
                  </Link>
                  <Nav>
                    <NavInner>
                      <Link to="/deals">Today's Deal's</Link>
                      <Link to="/popular">Popular Product's</Link>
                      <Link to="/top-selling">Top Selling</Link>
                    </NavInner>
                    <SearchContainer>
                      {/* <IoSearchOutline
                        style={{ fontSize: "30px", color: "#200E32" }}
                      /> */}
                      <img
                        src="/storage/general/Vector.svg"
                        alt="search-icon"
                      />
                      <Input
                        type="text"
                        id="search"
                        className="px-2"
                        placeholder="Search"
                        // value={props.search}
                        value={search}
                        onChange={(e) => getOptions(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSelectSearch(search);
                          }
                        }} // onChange={(e) => props.setSearch(e.target.value)}
                        autocomplete="off"
                      />
                      {filteredOptions.length > 0 && (
                        <SearchSuggestions>
                          {filteredOptions.map((option, index) => (
                            <Suggestion
                              key={index}
                              onClick={() =>
                                handleProductRoute(option?.product_slug)
                              }
                            >
                              {option.product_name}
                            </Suggestion>
                          ))}
                        </SearchSuggestions>
                      )}
                    </SearchContainer>
                  </Nav>
                  <Section className="top-btns">
                    <Buttons>
                      {/* <Button className="notification-style">
                        {wish && wish.length > 0 ? (
                          <Number>{wish.length}</Number>
                        ) : null}
                        <div>
                          <span>
                            <CiHeart />
                          </span>
                          <Link to={authenticated ? "/wishlist" : "/login"}>
                            Wishlist
                          </Link>
                        </div>
                      </Button> */}
                      <Button className="notification-style">
                        {cartData && cartData.length > 0 ? (
                          <Number>{cartData.length}</Number>
                        ) : null}
                        <div>
                          <div className="d-flex justify-content-between w-100">
                            <CartOwn />

                            <Link
                              to={authenticated ? "/wishlist" : "#"} onClick={(e) => { if (!authenticated) { e.preventDefault(); setIsLogin(true); const dlg = document.getElementById("dialog"); if (dlg && typeof dlg.showModal === "function") { dlg.showModal(); } } }}
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                marginLeft: "5px",
                                fontFamily: "Inter, sans-serif",
                              }}
                            >
                              Cart
                            </Link>
                          </div>
                        </div>
                      </Button>
                      {authenticated ? (
                        <Button
                          className="user"
                          onClick={handleOpenLoginDropDown}
                          data-login-dropdown="true"
                        >
                          <span>
                            <IoPersonOutline />
                          </span>
                          <div>
                            <Link to="/" onClick={() => props?.SearchFetch()}>
                              {" "}
                              {authenticated && `${name}`}
                            </Link>
                          </div>
                        </Button>
                      ) : (
                        <Button
                          onClick={handleOpenLoginDropDown}
                          className=" d-flex items-center gap-1"
                          data-login-dropdown="true"
                        // style={{fontSize:'18px', fontWeight:'500'}}
                        >
                          {/* <CiLogin />  */}
                          <LogInOut />
                          <div class="font-Inter font-bold text-lg leading-none tracking-normal text-black">
                            Login/Signup
                          </div>
                        </Button>
                      )}

                      {authenticated ? (
                        <LogoutModal open={openLoginDropdown} data-login-dropdown="true">
                          <div className="flex flex-col space-y-4 p-4 border border-bg-[rgba(200, 200, 200, 1)] bg-white rounded-[21px] shadow-md font-JostSans">
                            <Link
                              to="/myorders"
                              onClick={() => props?.SearchFetch()}
                            >
                              <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                                <svg
                                  className="w-5 h-5 mr-2"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                    clipRule="evenodd"
                                  ></path>
                                </svg>
                                My Orders
                              </button>
                            </Link>
                            <div onClick={handleLogout}>
                              <Link to="/" onClick={() => props?.SearchFetch()}>
                                <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                                  <svg
                                    className="w-5 h-5 mr-2"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                                      clipRule="evenodd"
                                    ></path>
                                  </svg>
                                  Logout
                                </button>
                              </Link>
                            </div>
                          </div>
                        </LogoutModal>
                      ) : (
                        <LogoutModal open={openLoginDropdown} data-login-dropdown="true">
                          <div className="flex flex-col space-y-4 pe-3 ps-2 py-3 bg-white border border-bg-[rgba(200, 200, 200, 1)] rounded-[21px] shadow-md font-JostSans">
                            {/* <Link
                              to="/login"
                              onClick={() => props?.SearchFetch()}
                            > */}
                            <button
                              command="show-modal"
                              commandfor="dialog"
                              onClick={() => setIsLogin(true)}
                              className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="15"
                                viewBox="0 0 12 15"
                                fill="none"
                                className="mr-4 mt-1"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M5.25 0C4.65326 0 4.08097 0.237053 3.65901 0.65901C3.23705 1.08097 3 1.65326 3 2.25V12.75C3 13.3467 3.23705 13.919 3.65901 14.341C4.08097 14.7629 4.65326 15 5.25 15H9.75C10.3467 15 10.919 14.7629 11.341 14.341C11.7629 13.919 12 13.3467 12 12.75V2.25C12 1.65326 11.7629 1.08097 11.341 0.65901C10.919 0.237053 10.3467 0 9.75 0H5.25ZM6.21975 4.71975C6.3604 4.57915 6.55113 4.50016 6.75 4.50016C6.94887 4.50016 7.1396 4.57915 7.28025 4.71975L9.53025 6.96975C9.67085 7.1104 9.74984 7.30113 9.74984 7.5C9.74984 7.69887 9.67085 7.8896 9.53025 8.03025L7.28025 10.2802C7.1388 10.4169 6.94935 10.4925 6.7527 10.4908C6.55605 10.489 6.36794 10.4102 6.22889 10.2711C6.08983 10.1321 6.01095 9.94395 6.00924 9.7473C6.00754 9.55065 6.08313 9.3612 6.21975 9.21975L7.1895 8.25H0.75C0.551088 8.25 0.360322 8.17098 0.21967 8.03033C0.0790178 7.88968 0 7.69891 0 7.5C0 7.30109 0.0790178 7.11032 0.21967 6.96967C0.360322 6.82902 0.551088 6.75 0.75 6.75H7.1895L6.21975 5.78025C6.07915 5.6396 6.00016 5.44887 6.00016 5.25C6.00016 5.05113 6.07915 4.8604 6.21975 4.71975Z"
                                  fill="black"
                                />
                              </svg>
                              Login
                            </button>
                            {/* </Link> */}
                            <button
                              command="show-modal"
                              commandfor="dialog"
                              onClick={() => setIsLogin(false)}
                              className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="13"
                                height="15"
                                viewBox="0 0 13 15"
                                fill="none"
                                className="mr-4 mt-1"
                              >
                                <path
                                  d="M11.4051 1.22204C11.206 1.02276 10.9695 0.864685 10.7091 0.756857C10.4488 0.649029 10.1698 0.593562 9.88808 0.593628C9.60633 0.593694 9.32735 0.649291 9.0671 0.75724C8.80684 0.86519 8.57042 1.02337 8.37134 1.22275L1.63721 7.96609C1.23596 8.36826 1.01053 8.91311 1.01034 9.48121L1.01034 11.75C1.01034 12.0433 1.24834 12.2813 1.54159 12.2813H3.82454C4.39334 12.2813 4.93875 12.0546 5.34038 11.653L12.0695 4.91955C12.4709 4.51719 12.6964 3.97205 12.6964 3.40371C12.6964 2.83537 12.4709 2.29023 12.0695 1.88788L11.4051 1.22204ZM0.833252 13.3438C0.692356 13.3438 0.55723 13.3997 0.457601 13.4994C0.357973 13.599 0.302002 13.7341 0.302002 13.875C0.302002 14.0159 0.357973 14.151 0.457601 14.2507C0.55723 14.3503 0.692356 14.4063 0.833252 14.4063H12.1666C12.3075 14.4063 12.4426 14.3503 12.5422 14.2507C12.6419 14.151 12.6978 14.0159 12.6978 13.875C12.6978 13.7341 12.6419 13.599 12.5422 13.4994C12.4426 13.3997 12.3075 13.3438 12.1666 13.3438H0.833252Z"
                                  fill="#1D1B20"
                                />
                              </svg>
                              Register
                            </button>
                          </div>
                        </LogoutModal>
                      )}
                    </Buttons>
                  </Section>
                </Container>
              </div>
            </Main>
            <ItemContainer>
              <Items>
                {data.map((item, i) => (
                  <Item
                    // style={{
                    //   backgroundColor:
                    //     selectedCategory === item.category_id && subcategory
                    //       ? "#e1f0da"
                    //       : "transparent",
                    // }}
                    key={i}
                    onMouseEnter={() => handleSubCategory(item.category_id)}
                    // onClick={() => setSubcategory(false)}
                    onClick={() => {
                      handleCategoryMain(item.category_slug);
                    }}
                  >
                    <ItemDiv>
                      <Link
                        to=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#000",
                          fontSize: "15px",
                        }}
                      >
                        <div>
                          <img
                            src={categoryurl + item.logo}
                            width={30}
                            height={30}
                          />{" "}
                        </div>
                        <div>{item.category_name}</div>
                      </Link>
                      <Arrow>
                        <BsChevronDown />
                      </Arrow>
                    </ItemDiv>
                    {subcategory && (
                      <Dropdown className="ml-3">
                        {subcategoryItems.length > 0 ? (
                          subcategoryItems.map((subItem, index) => (
                            <li key={index}>
                              <div
                                // to={`/subcategory/${subItem.sub_category_id}`}

                                // to={"/product-list"}
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent bubbling to parent
                                  handleSubCategoryRoute(
                                    subItem.sub_category_slug
                                  );
                                }}
                              >
                                {subItem.sub_category_name}
                              </div>
                            </li>
                          ))
                        ) : (
                          <ul className="ml-3">
                            <li>coming soon</li>
                          </ul>
                        )}
                      </Dropdown>
                    )}
                  </Item>
                ))}
              </Items>
            </ItemContainer>
          </Header>
          {/* mobile container */}
          <MobileHeader>
            <svg
              onClick={toggleMobileHeader}
              width="24"
              height="16"
              viewBox="0 0 24 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 16V13.3333H24V16H0ZM0 9.33333V6.66667H24V9.33333H0ZM0 2.66667V0H24V2.66667H0Z"
                fill="#62BC00"
              />
            </svg>

            <Link to="/">
              <ImageContainer>
                <img src="/storage/general/ks-logo32.png" />
              </ImageContainer>
            </Link>
            <div className="d-flex justify-content-end w-100">
              {authenticated ? (
                <Button className="user" onClick={handleOpenLoginDropDown} data-login-dropdown="true">
                  <span>
                    <IoPersonOutline />
                  </span>
                  <div>
                    <Link to="/" onClick={() => props?.SearchFetch()}>
                      {" "}
                      {authenticated && `${name}`}
                    </Link>
                  </div>
                </Button>
              ) : (
                <Button
                  onClick={handleOpenLoginDropDown}
                  className=" d-flex items-center gap-1"
                  data-login-dropdown="true"
                // style={{fontSize:'18px', fontWeight:'500'}}
                >
                  <svg
                    width="73"
                    height="12"
                    viewBox="0 0 73 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.936 0.599999H2.352V7.728H5.688V9H0.936V0.599999ZM6.18534 6.24C6.18534 5.672 6.31334 5.172 6.56934 4.74C6.83334 4.308 7.18934 3.972 7.63734 3.732C8.08534 3.484 8.59334 3.36 9.16134 3.36C9.72934 3.36 10.2333 3.484 10.6733 3.732C11.1213 3.972 11.4773 4.308 11.7413 4.74C12.0053 5.172 12.1373 5.672 12.1373 6.24C12.1373 6.8 12.0053 7.3 11.7413 7.74C11.4773 8.172 11.1213 8.512 10.6733 8.76C10.2333 9 9.72934 9.12 9.16134 9.12C8.59334 9.12 8.08534 9 7.63734 8.76C7.18934 8.512 6.83334 8.172 6.56934 7.74C6.31334 7.3 6.18534 6.8 6.18534 6.24ZM7.51734 6.24C7.51734 6.584 7.58934 6.888 7.73334 7.152C7.87734 7.408 8.07334 7.612 8.32134 7.764C8.56934 7.908 8.84934 7.98 9.16134 7.98C9.46534 7.98 9.74134 7.908 9.98934 7.764C10.2453 7.612 10.4453 7.408 10.5893 7.152C10.7333 6.888 10.8053 6.584 10.8053 6.24C10.8053 5.896 10.7333 5.592 10.5893 5.328C10.4453 5.064 10.2453 4.86 9.98934 4.716C9.74134 4.572 9.46534 4.5 9.16134 4.5C8.84934 4.5 8.56934 4.572 8.32134 4.716C8.07334 4.86 7.87734 5.064 7.73334 5.328C7.58934 5.592 7.51734 5.896 7.51734 6.24ZM13.0551 9.372H14.3391C14.3471 9.62 14.4151 9.844 14.5431 10.044C14.6791 10.244 14.8631 10.4 15.0951 10.512C15.3271 10.624 15.5951 10.68 15.8991 10.68C16.1711 10.68 16.4311 10.616 16.6791 10.488C16.9271 10.36 17.1271 10.164 17.2791 9.9C17.4391 9.636 17.5191 9.296 17.5191 8.88V3.48H18.7911V8.88C18.7911 9.544 18.6551 10.092 18.3831 10.524C18.1191 10.956 17.7711 11.276 17.3391 11.484C16.9071 11.7 16.4391 11.808 15.9351 11.808C15.3351 11.808 14.8231 11.704 14.3991 11.496C13.9751 11.296 13.6471 11.012 13.4151 10.644C13.1911 10.276 13.0711 9.852 13.0551 9.372ZM12.9471 6.216C12.9471 5.6 13.0711 5.084 13.3191 4.668C13.5671 4.244 13.8951 3.92 14.3031 3.696C14.7191 3.472 15.1631 3.36 15.6351 3.36C16.0991 3.36 16.5031 3.476 16.8471 3.708C17.1991 3.932 17.4751 4.256 17.6751 4.68C17.8831 5.104 17.9871 5.616 17.9871 6.216C17.9871 6.808 17.8831 7.316 17.6751 7.74C17.4751 8.164 17.1991 8.492 16.8471 8.724C16.5031 8.948 16.0991 9.06 15.6351 9.06C15.1631 9.06 14.7191 8.948 14.3031 8.724C13.8951 8.5 13.5671 8.176 13.3191 7.752C13.0711 7.328 12.9471 6.816 12.9471 6.216ZM14.2911 6.216C14.2911 6.584 14.3671 6.896 14.5191 7.152C14.6711 7.408 14.8711 7.604 15.1191 7.74C15.3751 7.868 15.6511 7.932 15.9471 7.932C16.1951 7.932 16.4391 7.868 16.6791 7.74C16.9271 7.612 17.1271 7.42 17.2791 7.164C17.4391 6.9 17.5191 6.584 17.5191 6.216C17.5191 5.928 17.4711 5.68 17.3751 5.472C17.2871 5.256 17.1671 5.076 17.0151 4.932C16.8631 4.78 16.6911 4.668 16.4991 4.596C16.3151 4.524 16.1311 4.488 15.9471 4.488C15.6511 4.488 15.3751 4.556 15.1191 4.692C14.8711 4.82 14.6711 5.012 14.5191 5.268C14.3671 5.524 14.2911 5.84 14.2911 6.216ZM20.3503 1.284C20.3503 1.06 20.4303 0.872 20.5903 0.719999C20.7583 0.567999 20.9503 0.491999 21.1663 0.491999C21.3983 0.491999 21.5903 0.567999 21.7423 0.719999C21.9023 0.872 21.9823 1.06 21.9823 1.284C21.9823 1.5 21.9023 1.688 21.7423 1.848C21.5903 2 21.3983 2.076 21.1663 2.076C20.9503 2.076 20.7583 2 20.5903 1.848C20.4303 1.688 20.3503 1.5 20.3503 1.284ZM20.5303 3.48H21.8023V9H20.5303V3.48ZM27.1378 5.64C27.1378 5.232 27.0538 4.924 26.8858 4.716C26.7178 4.508 26.4578 4.404 26.1058 4.404C25.8658 4.404 25.6538 4.456 25.4698 4.56C25.2858 4.656 25.1418 4.8 25.0378 4.992C24.9338 5.176 24.8818 5.392 24.8818 5.64V9H23.5858V3.48H24.8818V4.332C25.0578 4.004 25.2818 3.76 25.5538 3.6C25.8338 3.44 26.1658 3.36 26.5498 3.36C27.1738 3.36 27.6498 3.552 27.9778 3.936C28.3058 4.312 28.4698 4.832 28.4698 5.496V9H27.1378V5.64ZM34.4689 0.599999H35.7409L30.7849 10.8H29.4769L34.4689 0.599999ZM37.406 6.3C37.59 6.62 37.786 6.904 37.994 7.152C38.21 7.392 38.446 7.58 38.702 7.716C38.958 7.844 39.246 7.908 39.566 7.908C39.95 7.908 40.262 7.804 40.502 7.596C40.742 7.388 40.862 7.12 40.862 6.792C40.862 6.48 40.786 6.232 40.634 6.048C40.482 5.856 40.27 5.696 39.998 5.568C39.734 5.432 39.426 5.3 39.074 5.172C38.866 5.1 38.634 5.004 38.378 4.884C38.122 4.756 37.878 4.6 37.646 4.416C37.414 4.224 37.222 3.992 37.07 3.72C36.918 3.44 36.842 3.104 36.842 2.712C36.842 2.264 36.958 1.872 37.19 1.536C37.422 1.192 37.734 0.928 38.126 0.744C38.526 0.552 38.978 0.456 39.482 0.456C39.978 0.456 40.41 0.544 40.778 0.719999C41.146 0.895999 41.454 1.12 41.702 1.392C41.958 1.664 42.158 1.948 42.302 2.244L41.15 2.892C41.046 2.684 40.914 2.492 40.754 2.316C40.594 2.132 40.406 1.988 40.19 1.884C39.982 1.772 39.738 1.716 39.458 1.716C39.066 1.716 38.778 1.808 38.594 1.992C38.41 2.168 38.318 2.376 38.318 2.616C38.318 2.832 38.382 3.028 38.51 3.204C38.646 3.372 38.854 3.532 39.134 3.684C39.414 3.836 39.778 3.992 40.226 4.152C40.474 4.24 40.722 4.352 40.97 4.488C41.226 4.624 41.458 4.796 41.666 5.004C41.874 5.204 42.038 5.44 42.158 5.712C42.286 5.984 42.35 6.304 42.35 6.672C42.35 7.064 42.274 7.416 42.122 7.728C41.97 8.04 41.762 8.304 41.498 8.52C41.234 8.728 40.934 8.888 40.598 9C40.27 9.12 39.926 9.18 39.566 9.18C39.07 9.18 38.61 9.084 38.186 8.892C37.77 8.692 37.406 8.428 37.094 8.1C36.782 7.772 36.534 7.416 36.35 7.032L37.406 6.3ZM43.6472 1.284C43.6472 1.06 43.7272 0.872 43.8872 0.719999C44.0552 0.567999 44.2472 0.491999 44.4632 0.491999C44.6952 0.491999 44.8872 0.567999 45.0392 0.719999C45.1992 0.872 45.2792 1.06 45.2792 1.284C45.2792 1.5 45.1992 1.688 45.0392 1.848C44.8872 2 44.6952 2.076 44.4632 2.076C44.2472 2.076 44.0552 2 43.8872 1.848C43.7272 1.688 43.6472 1.5 43.6472 1.284ZM43.8272 3.48H45.0992V9H43.8272V3.48ZM46.5707 9.372H47.8547C47.8627 9.62 47.9307 9.844 48.0587 10.044C48.1947 10.244 48.3787 10.4 48.6107 10.512C48.8427 10.624 49.1107 10.68 49.4147 10.68C49.6867 10.68 49.9467 10.616 50.1947 10.488C50.4427 10.36 50.6427 10.164 50.7947 9.9C50.9547 9.636 51.0347 9.296 51.0347 8.88V3.48H52.3067V8.88C52.3067 9.544 52.1707 10.092 51.8987 10.524C51.6347 10.956 51.2867 11.276 50.8547 11.484C50.4227 11.7 49.9547 11.808 49.4507 11.808C48.8507 11.808 48.3387 11.704 47.9147 11.496C47.4907 11.296 47.1627 11.012 46.9307 10.644C46.7067 10.276 46.5867 9.852 46.5707 9.372ZM46.4627 6.216C46.4627 5.6 46.5867 5.084 46.8347 4.668C47.0827 4.244 47.4107 3.92 47.8187 3.696C48.2347 3.472 48.6787 3.36 49.1507 3.36C49.6147 3.36 50.0187 3.476 50.3627 3.708C50.7147 3.932 50.9907 4.256 51.1907 4.68C51.3987 5.104 51.5027 5.616 51.5027 6.216C51.5027 6.808 51.3987 7.316 51.1907 7.74C50.9907 8.164 50.7147 8.492 50.3627 8.724C50.0187 8.948 49.6147 9.06 49.1507 9.06C48.6787 9.06 48.2347 8.948 47.8187 8.724C47.4107 8.5 47.0827 8.176 46.8347 7.752C46.5867 7.328 46.4627 6.816 46.4627 6.216ZM47.8067 6.216C47.8067 6.584 47.8827 6.896 48.0347 7.152C48.1867 7.408 48.3867 7.604 48.6347 7.74C48.8907 7.868 49.1667 7.932 49.4627 7.932C49.7107 7.932 49.9547 7.868 50.1947 7.74C50.4427 7.612 50.6427 7.42 50.7947 7.164C50.9547 6.9 51.0347 6.584 51.0347 6.216C51.0347 5.928 50.9867 5.68 50.8907 5.472C50.8027 5.256 50.6827 5.076 50.5307 4.932C50.3787 4.78 50.2067 4.668 50.0147 4.596C49.8307 4.524 49.6467 4.488 49.4627 4.488C49.1667 4.488 48.8907 4.556 48.6347 4.692C48.3867 4.82 48.1867 5.012 48.0347 5.268C47.8827 5.524 47.8067 5.84 47.8067 6.216ZM57.4659 5.64C57.4659 5.232 57.3819 4.924 57.2139 4.716C57.0459 4.508 56.7859 4.404 56.4339 4.404C56.1939 4.404 55.9819 4.456 55.7979 4.56C55.6139 4.656 55.4699 4.8 55.3659 4.992C55.2619 5.176 55.2099 5.392 55.2099 5.64V9H53.9139V3.48H55.2099V4.332C55.3859 4.004 55.6099 3.76 55.8819 3.6C56.1619 3.44 56.4939 3.36 56.8779 3.36C57.5019 3.36 57.9779 3.552 58.3059 3.936C58.6339 4.312 58.7979 4.832 58.7979 5.496V9H57.4659V5.64ZM61.785 6.84C61.785 7.232 61.869 7.536 62.037 7.752C62.205 7.968 62.461 8.076 62.805 8.076C63.053 8.076 63.269 8.028 63.453 7.932C63.637 7.828 63.781 7.684 63.885 7.5C63.989 7.308 64.041 7.088 64.041 6.84V3.48H65.337V9H64.041V8.148C63.865 8.468 63.637 8.712 63.357 8.88C63.085 9.04 62.757 9.12 62.373 9.12C61.757 9.12 61.281 8.928 60.945 8.544C60.617 8.16 60.453 7.64 60.453 6.984V3.48H61.785V6.84ZM68.2521 11.64H66.9441V3.48H68.2521V11.64ZM72.8241 6.24C72.8241 6.848 72.7001 7.372 72.4521 7.812C72.2041 8.244 71.8761 8.576 71.4681 8.808C71.0601 9.032 70.6161 9.144 70.1361 9.144C69.6641 9.144 69.2521 9.028 68.9001 8.796C68.5561 8.556 68.2881 8.22 68.0961 7.788C67.9121 7.348 67.8201 6.832 67.8201 6.24C67.8201 5.64 67.9121 5.124 68.0961 4.692C68.2881 4.26 68.5561 3.928 68.9001 3.696C69.2521 3.456 69.6641 3.336 70.1361 3.336C70.6161 3.336 71.0601 3.452 71.4681 3.684C71.8761 3.908 72.2041 4.236 72.4521 4.668C72.7001 5.1 72.8241 5.624 72.8241 6.24ZM71.4801 6.24C71.4801 5.872 71.4041 5.56 71.2521 5.304C71.1001 5.04 70.8961 4.844 70.6401 4.716C70.3921 4.58 70.1161 4.512 69.8121 4.512C69.5641 4.512 69.3201 4.58 69.0801 4.716C68.8401 4.844 68.6401 5.036 68.4801 5.292C68.3281 5.548 68.2521 5.864 68.2521 6.24C68.2521 6.616 68.3281 6.932 68.4801 7.188C68.6401 7.444 68.8401 7.64 69.0801 7.776C69.3201 7.904 69.5641 7.968 69.8121 7.968C70.1161 7.968 70.3921 7.904 70.6401 7.776C70.8961 7.64 71.1001 7.444 71.2521 7.188C71.4041 6.924 71.4801 6.608 71.4801 6.24Z"
                      fill="#222222"
                    />
                  </svg>
                </Button>
              )}
            </div>
            {authenticated ? (
              <LogoutModalMobileSec open={openLoginDropdown} data-login-dropdown="true">
                <div className="flex flex-col space-y-4 p-4 border border-bg-[rgba(200, 200, 200, 1)] bg-white rounded-[21px] shadow-md font-JostSans">
                  <Link to="/myorders" onClick={() => props?.SearchFetch()}>
                    <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                      <svg
                        className="w-5 h-5 mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      My Orders
                    </button>
                  </Link>
                  <div onClick={handleLogout}>
                    <Link to="/" onClick={() => props?.SearchFetch()}>
                      <button className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full">
                        <svg
                          className="w-5 h-5 mr-2"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                        Logout
                      </button>
                    </Link>
                  </div>
                </div>
              </LogoutModalMobileSec>
            ) : (
              <LogoutModalMobileSec open={openLoginDropdown} data-login-dropdown="true">
                <div className="flex flex-col space-y-4 pe-3 ps-2 py-3 bg-white border border-bg-[rgba(200, 200, 200, 1)] rounded-[21px] shadow-md font-JostSans">
                  {/* <Link
                              to="/login"
                              onClick={() => props?.SearchFetch()}
                            > */}
                  <button
                    command="show-modal"
                    commandfor="dialog"
                    onClick={() => setIsLogin(true)}
                    className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="15"
                      viewBox="0 0 12 15"
                      fill="none"
                      className="mr-4 mt-1"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.25 0C4.65326 0 4.08097 0.237053 3.65901 0.65901C3.23705 1.08097 3 1.65326 3 2.25V12.75C3 13.3467 3.23705 13.919 3.65901 14.341C4.08097 14.7629 4.65326 15 5.25 15H9.75C10.3467 15 10.919 14.7629 11.341 14.341C11.7629 13.919 12 13.3467 12 12.75V2.25C12 1.65326 11.7629 1.08097 11.341 0.65901C10.919 0.237053 10.3467 0 9.75 0H5.25ZM6.21975 4.71975C6.3604 4.57915 6.55113 4.50016 6.75 4.50016C6.94887 4.50016 7.1396 4.57915 7.28025 4.71975L9.53025 6.96975C9.67085 7.1104 9.74984 7.30113 9.74984 7.5C9.74984 7.69887 9.67085 7.8896 9.53025 8.03025L7.28025 10.2802C7.1388 10.4169 6.94935 10.4925 6.7527 10.4908C6.55605 10.489 6.36794 10.4102 6.22889 10.2711C6.08983 10.1321 6.01095 9.94395 6.00924 9.7473C6.00754 9.55065 6.08313 9.3612 6.21975 9.21975L7.1895 8.25H0.75C0.551088 8.25 0.360322 8.17098 0.21967 8.03033C0.0790178 7.88968 0 7.69891 0 7.5C0 7.30109 0.0790178 7.11032 0.21967 6.96967C0.360322 6.82902 0.551088 6.75 0.75 6.75H7.1895L6.21975 5.78025C6.07915 5.6396 6.00016 5.44887 6.00016 5.25C6.00016 5.05113 6.07915 4.8604 6.21975 4.71975Z"
                        fill="black"
                      />
                    </svg>
                    Login
                  </button>
                  {/* </Link> */}
                  <button
                    command="show-modal"
                    commandfor="dialog"
                    onClick={() => setIsLogin(false)}
                    className="flex items-start justify-start text-black font-medium py-1 px-4 rounded w-full"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="15"
                      viewBox="0 0 13 15"
                      fill="none"
                      className="mr-4 mt-1"
                    >
                      <path
                        d="M11.4051 1.22204C11.206 1.02276 10.9695 0.864685 10.7091 0.756857C10.4488 0.649029 10.1698 0.593562 9.88808 0.593628C9.60633 0.593694 9.32735 0.649291 9.0671 0.75724C8.80684 0.86519 8.57042 1.02337 8.37134 1.22275L1.63721 7.96609C1.23596 8.36826 1.01053 8.91311 1.01034 9.48121L1.01034 11.75C1.01034 12.0433 1.24834 12.2813 1.54159 12.2813H3.82454C4.39334 12.2813 4.93875 12.0546 5.34038 11.653L12.0695 4.91955C12.4709 4.51719 12.6964 3.97205 12.6964 3.40371C12.6964 2.83537 12.4709 2.29023 12.0695 1.88788L11.4051 1.22204ZM0.833252 13.3438C0.692356 13.3438 0.55723 13.3997 0.457601 13.4994C0.357973 13.599 0.302002 13.7341 0.302002 13.875C0.302002 14.0159 0.357973 14.151 0.457601 14.2507C0.55723 14.3503 0.692356 14.4063 0.833252 14.4063H12.1666C12.3075 14.4063 12.4426 14.3503 12.5422 14.2507C12.6419 14.151 12.6978 14.0159 12.6978 13.875C12.6978 13.7341 12.6419 13.599 12.5422 13.4994C12.4426 13.3997 12.3075 13.3438 12.1666 13.3438H0.833252Z"
                        fill="#1D1B20"
                      />
                    </svg>
                    Register
                  </button>
                </div>
              </LogoutModalMobileSec>
            )}
          </MobileHeader>
          <MobileHeaderSearch>
            <SearchContainerOld className="">
              <Input
                // className="mobile-search px-2"
                type="text"
                placeholder="Search"
                // value={props.search}
                value={search}
                onChange={(e) => getOptions(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSelectSearch(search);
                  }
                }} // onChange={(e) => props.setSearch(e.target.value)}
                autocomplete="off"
              />
              {/* <IoSearchOutline /> */}
              <img src="/storage/general/Vector.svg" alt="search-icon" />
              {filteredOptions.length > 0 && (
                <SearchSuggestions className="mobile">
                  {filteredOptions.map((option, index) => (
                    <Suggestion
                      key={index}
                      onClick={() => handleProductRoute(option?.product_slug)}
                    >
                      {option.product_name}
                    </Suggestion>
                  ))}
                </SearchSuggestions>
              )}
            </SearchContainerOld>
          </MobileHeaderSearch>
          <Slider className={isMobileHeaderActive ? "active" : ""}>
            <MobileTop>
              <Link to="/">
                <ImageContainer>
                  <img src="/storage/general/ks-logo32.png" />
                </ImageContainer>
              </Link>
              <div onClick={toggleMobileHeader}>
                <IoCloseOutline />
              </div>
            </MobileTop>
            <Socials className="mobile">
              <a
                target="_blank"
                href="https://www.facebook.com/myKeralaspecial?mibextid=qi2Omg&rdid=kccxW9NpVX3BFzrU&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FXM1oRDDkvagcQKW9%2F%3Fmibextid%3Dqi2Omg"
              >
                <GrFacebookOption />
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/keralaspecial/"
              >
                <LiaInstagram />
              </a>
              <a
                target="_blank"
                href="https://www.youtube.com/@keralaspecial5256"
              >
                <AiFillYoutube />
              </a>
              <a
                target="_blank"
                href="https://x.com/mykeralaspecial?t=5jaIdWgLfUhVzxywcQto9g"
              >
                <RiTwitterXLine />
              </a>
            </Socials>
            <Buttons className="mobile">
              {!authenticated ? (
                <>
                  {/* <Link to="/login" onClick={() => props?.SearchFetch()}>
                    {" "}
                    <button className="">LOGIN</button>
                  </Link>
                  <Link to="/register">
                    <button className="">REGISTER</button>
                  </Link> */}
                </>
              ) : (
                <>
                  <div className="">
                    <Link to="/myorders" onClick={() => props?.SearchFetch()}>
                      {" "}
                      <button className="">MY ORDERS</button>
                    </Link>
                  </div>
                  <div className="" onClick={handleLogout}>
                    <Link to="/" onClick={() => props?.SearchFetch()}>
                      {" "}
                      <button className="">LOGOUT</button>
                    </Link>
                  </div>
                </>
              )}
              {/* <LoginBtn>
                <Link to="/login">Login</Link>
              </LoginBtn>
              <LoginBtn>
                <Link to="/register">Register</Link>
              </LoginBtn> */}
            </Buttons>
            <Nav className="mobile">
              <Link to="/">Home</Link>
              <Link to="/about-us">About Us</Link>
              <Link to="/blog">Blogs</Link>
              <Link to="/contact-us">Contact Us</Link>
            </Nav>
            <P>Copyright</P>
          </Slider>
          <MobileHeaderBottom>
            <Buttons className="bottom">
              <Link to={"/"} className="flex items-center gap-1">
                <svg
                  width="30"
                  height="45"
                  viewBox="0 0 30 45"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 11.0859V25.75C3 27.5449 4.45507 29 6.25 29C8.04493 29 9.5 27.5449 9.5 25.75V21.2982C9.5 19.0891 11.2909 17.2982 13.5 17.2982H16.5C18.7091 17.2982 20.5 19.0891 20.5 21.2982V25.75C20.5 27.5449 21.9551 29 23.75 29C25.5449 29 27 27.5449 27 25.75V11.186C27 9.91118 26.3923 8.71271 25.364 7.9593L16.9652 1.80607C15.5098 0.73981 13.5208 0.779807 12.1094 1.90372L4.50821 7.95685C3.5552 8.71577 3 9.86763 3 11.0859Z"
                    fill="#187837"
                  />
                  LOGIN
                  <path
                    d="M6.14 34.03V41H5.23V37.84H1.68V41H0.77V34.03H1.68V37.09H5.23V34.03H6.14ZM10.0838 41.09C9.57049 41.09 9.10383 40.9733 8.68383 40.74C8.27049 40.5067 7.94383 40.1767 7.70383 39.75C7.47049 39.3167 7.35383 38.8167 7.35383 38.25C7.35383 37.69 7.47383 37.1967 7.71383 36.77C7.96049 36.3367 8.29383 36.0067 8.71383 35.78C9.13383 35.5467 9.60383 35.43 10.1238 35.43C10.6438 35.43 11.1138 35.5467 11.5338 35.78C11.9538 36.0067 12.2838 36.3333 12.5238 36.76C12.7705 37.1867 12.8938 37.6833 12.8938 38.25C12.8938 38.8167 12.7672 39.3167 12.5138 39.75C12.2672 40.1767 11.9305 40.5067 11.5038 40.74C11.0772 40.9733 10.6038 41.09 10.0838 41.09ZM10.0838 40.29C10.4105 40.29 10.7172 40.2133 11.0038 40.06C11.2905 39.9067 11.5205 39.6767 11.6938 39.37C11.8738 39.0633 11.9638 38.69 11.9638 38.25C11.9638 37.81 11.8772 37.4367 11.7038 37.13C11.5305 36.8233 11.3038 36.5967 11.0238 36.45C10.7438 36.2967 10.4405 36.22 10.1138 36.22C9.78049 36.22 9.47383 36.2967 9.19383 36.45C8.92049 36.5967 8.70049 36.8233 8.53383 37.13C8.36716 37.4367 8.28383 37.81 8.28383 38.25C8.28383 38.6967 8.36383 39.0733 8.52383 39.38C8.69049 39.6867 8.91049 39.9167 9.18383 40.07C9.45716 40.2167 9.75716 40.29 10.0838 40.29ZM20.6803 35.42C21.107 35.42 21.487 35.51 21.8203 35.69C22.1536 35.8633 22.417 36.1267 22.6103 36.48C22.8036 36.8333 22.9003 37.2633 22.9003 37.77V41H22.0003V37.9C22.0003 37.3533 21.8636 36.9367 21.5903 36.65C21.3236 36.3567 20.9603 36.21 20.5003 36.21C20.027 36.21 19.6503 36.3633 19.3703 36.67C19.0903 36.97 18.9503 37.4067 18.9503 37.98V41H18.0503V37.9C18.0503 37.3533 17.9136 36.9367 17.6403 36.65C17.3736 36.3567 17.0103 36.21 16.5503 36.21C16.077 36.21 15.7003 36.3633 15.4203 36.67C15.1403 36.97 15.0003 37.4067 15.0003 37.98V41H14.0903V35.52H15.0003V36.31C15.1803 36.0233 15.4203 35.8033 15.7203 35.65C16.027 35.4967 16.3636 35.42 16.7303 35.42C17.1903 35.42 17.597 35.5233 17.9503 35.73C18.3036 35.9367 18.567 36.24 18.7403 36.64C18.8936 36.2533 19.147 35.9533 19.5003 35.74C19.8536 35.5267 20.247 35.42 20.6803 35.42ZM29.393 38.05C29.393 38.2233 29.383 38.4067 29.363 38.6H24.983C25.0164 39.14 25.1997 39.5633 25.533 39.87C25.873 40.17 26.283 40.32 26.763 40.32C27.1564 40.32 27.483 40.23 27.743 40.05C28.0097 39.8633 28.1964 39.6167 28.303 39.31H29.283C29.1364 39.8367 28.843 40.2667 28.403 40.6C27.963 40.9267 27.4164 41.09 26.763 41.09C26.243 41.09 25.7764 40.9733 25.363 40.74C24.9564 40.5067 24.6364 40.1767 24.403 39.75C24.1697 39.3167 24.053 38.8167 24.053 38.25C24.053 37.6833 24.1664 37.1867 24.393 36.76C24.6197 36.3333 24.9364 36.0067 25.343 35.78C25.7564 35.5467 26.2297 35.43 26.763 35.43C27.283 35.43 27.743 35.5433 28.143 35.77C28.543 35.9967 28.8497 36.31 29.063 36.71C29.283 37.1033 29.393 37.55 29.393 38.05ZM28.453 37.86C28.453 37.5133 28.3764 37.2167 28.223 36.97C28.0697 36.7167 27.8597 36.5267 27.593 36.4C27.333 36.2667 27.043 36.2 26.723 36.2C26.263 36.2 25.8697 36.3467 25.543 36.64C25.223 36.9333 25.0397 37.34 24.993 37.86H28.453Z"
                    fill="black"
                  />
                </svg>
              </Link>
              <Button
                onClick={handleOpenCategory}
                className="mobile flex items-center gap-1"
              >
                <svg
                  width="57"
                  height="44"
                  viewBox="0 0 57 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M39.376 5.88257C40.2354 3.48379 37.834 1.20743 35.4846 2.19368L19.2391 9.01313C16.6495 10.1002 16.926 13.8557 19.6468 14.5519L23.0274 15.4169C24.4711 15.7863 25.6671 16.7948 26.2749 18.1555L28.1316 22.3124C29.2082 24.7228 32.6734 24.5909 33.5638 22.1057L39.376 5.88257ZM34.7287 0.393054C38.6445 -1.2507 42.6467 2.54325 41.2144 6.54121L35.4022 22.7644C33.9183 26.9064 28.1429 27.1261 26.3486 23.1089L24.4918 18.952C24.1271 18.1355 23.4096 17.5304 22.5433 17.3088L19.1627 16.4438C14.628 15.2835 14.1673 9.02425 18.4833 7.21251L34.7287 0.393054Z"
                    fill="black"
                  />
                  <path
                    d="M0.93 36.51C0.93 35.83 1.08333 35.22 1.39 34.68C1.69667 34.1333 2.11333 33.7067 2.64 33.4C3.17333 33.0933 3.76333 32.94 4.41 32.94C5.17 32.94 5.83333 33.1233 6.4 33.49C6.96667 33.8567 7.38 34.3767 7.64 35.05H6.55C6.35667 34.63 6.07667 34.3067 5.71 34.08C5.35 33.8533 4.91667 33.74 4.41 33.74C3.92333 33.74 3.48667 33.8533 3.1 34.08C2.71333 34.3067 2.41 34.63 2.19 35.05C1.97 35.4633 1.86 35.95 1.86 36.51C1.86 37.0633 1.97 37.55 2.19 37.97C2.41 38.3833 2.71333 38.7033 3.1 38.93C3.48667 39.1567 3.92333 39.27 4.41 39.27C4.91667 39.27 5.35 39.16 5.71 38.94C6.07667 38.7133 6.35667 38.39 6.55 37.97H7.64C7.38 38.6367 6.96667 39.1533 6.4 39.52C5.83333 39.88 5.17 40.06 4.41 40.06C3.76333 40.06 3.17333 39.91 2.64 39.61C2.11333 39.3033 1.69667 38.88 1.39 38.34C1.08333 37.8 0.93 37.19 0.93 36.51ZM8.65461 37.24C8.65461 36.68 8.76794 36.19 8.99461 35.77C9.22128 35.3433 9.53128 35.0133 9.92461 34.78C10.3246 34.5467 10.7679 34.43 11.2546 34.43C11.7346 34.43 12.1513 34.5333 12.5046 34.74C12.8579 34.9467 13.1213 35.2067 13.2946 35.52V34.52H14.2146V40H13.2946V38.98C13.1146 39.3 12.8446 39.5667 12.4846 39.78C12.1313 39.9867 11.7179 40.09 11.2446 40.09C10.7579 40.09 10.3179 39.97 9.92461 39.73C9.53128 39.49 9.22128 39.1533 8.99461 38.72C8.76794 38.2867 8.65461 37.7933 8.65461 37.24ZM13.2946 37.25C13.2946 36.8367 13.2113 36.4767 13.0446 36.17C12.8779 35.8633 12.6513 35.63 12.3646 35.47C12.0846 35.3033 11.7746 35.22 11.4346 35.22C11.0946 35.22 10.7846 35.3 10.5046 35.46C10.2246 35.62 10.0013 35.8533 9.83461 36.16C9.66794 36.4667 9.58461 36.8267 9.58461 37.24C9.58461 37.66 9.66794 38.0267 9.83461 38.34C10.0013 38.6467 10.2246 38.8833 10.5046 39.05C10.7846 39.21 11.0946 39.29 11.4346 39.29C11.7746 39.29 12.0846 39.21 12.3646 39.05C12.6513 38.8833 12.8779 38.6467 13.0446 38.34C13.2113 38.0267 13.2946 37.6633 13.2946 37.25ZM16.8624 35.27V38.5C16.8624 38.7667 16.9191 38.9567 17.0324 39.07C17.1458 39.1767 17.3424 39.23 17.6224 39.23H18.2924V40H17.4724C16.9658 40 16.5858 39.8833 16.3324 39.65C16.0791 39.4167 15.9524 39.0333 15.9524 38.5V35.27H15.2424V34.52H15.9524V33.14H16.8624V34.52H18.2924V35.27H16.8624ZM24.395 37.05C24.395 37.2233 24.385 37.4067 24.365 37.6H19.985C20.0183 38.14 20.2017 38.5633 20.535 38.87C20.875 39.17 21.285 39.32 21.765 39.32C22.1583 39.32 22.485 39.23 22.745 39.05C23.0117 38.8633 23.1983 38.6167 23.305 38.31H24.285C24.1383 38.8367 23.845 39.2667 23.405 39.6C22.965 39.9267 22.4183 40.09 21.765 40.09C21.245 40.09 20.7783 39.9733 20.365 39.74C19.9583 39.5067 19.6383 39.1767 19.405 38.75C19.1717 38.3167 19.055 37.8167 19.055 37.25C19.055 36.6833 19.1683 36.1867 19.395 35.76C19.6217 35.3333 19.9383 35.0067 20.345 34.78C20.7583 34.5467 21.2317 34.43 21.765 34.43C22.285 34.43 22.745 34.5433 23.145 34.77C23.545 34.9967 23.8517 35.31 24.065 35.71C24.285 36.1033 24.395 36.55 24.395 37.05ZM23.455 36.86C23.455 36.5133 23.3783 36.2167 23.225 35.97C23.0717 35.7167 22.8617 35.5267 22.595 35.4C22.335 35.2667 22.045 35.2 21.725 35.2C21.265 35.2 20.8717 35.3467 20.545 35.64C20.225 35.9333 20.0417 36.34 19.995 36.86H23.455ZM27.8562 34.43C28.3295 34.43 28.7428 34.5333 29.0962 34.74C29.4562 34.9467 29.7228 35.2067 29.8962 35.52V34.52H30.8162V40.12C30.8162 40.62 30.7095 41.0633 30.4962 41.45C30.2828 41.8433 29.9762 42.15 29.5762 42.37C29.1828 42.59 28.7228 42.7 28.1962 42.7C27.4762 42.7 26.8762 42.53 26.3962 42.19C25.9162 41.85 25.6328 41.3867 25.5462 40.8H26.4462C26.5462 41.1333 26.7528 41.4 27.0662 41.6C27.3795 41.8067 27.7562 41.91 28.1962 41.91C28.6962 41.91 29.1028 41.7533 29.4162 41.44C29.7362 41.1267 29.8962 40.6867 29.8962 40.12V38.97C29.7162 39.29 29.4495 39.5567 29.0962 39.77C28.7428 39.9833 28.3295 40.09 27.8562 40.09C27.3695 40.09 26.9262 39.97 26.5262 39.73C26.1328 39.49 25.8228 39.1533 25.5962 38.72C25.3695 38.2867 25.2562 37.7933 25.2562 37.24C25.2562 36.68 25.3695 36.19 25.5962 35.77C25.8228 35.3433 26.1328 35.0133 26.5262 34.78C26.9262 34.5467 27.3695 34.43 27.8562 34.43ZM29.8962 37.25C29.8962 36.8367 29.8128 36.4767 29.6462 36.17C29.4795 35.8633 29.2528 35.63 28.9662 35.47C28.6862 35.3033 28.3762 35.22 28.0362 35.22C27.6962 35.22 27.3862 35.3 27.1062 35.46C26.8262 35.62 26.6028 35.8533 26.4362 36.16C26.2695 36.4667 26.1862 36.8267 26.1862 37.24C26.1862 37.66 26.2695 38.0267 26.4362 38.34C26.6028 38.6467 26.8262 38.8833 27.1062 39.05C27.3862 39.21 27.6962 39.29 28.0362 39.29C28.3762 39.29 28.6862 39.21 28.9662 39.05C29.2528 38.8833 29.4795 38.6467 29.6462 38.34C29.8128 38.0267 29.8962 37.6633 29.8962 37.25ZM34.744 40.09C34.2307 40.09 33.764 39.9733 33.344 39.74C32.9307 39.5067 32.604 39.1767 32.364 38.75C32.1307 38.3167 32.014 37.8167 32.014 37.25C32.014 36.69 32.134 36.1967 32.374 35.77C32.6207 35.3367 32.954 35.0067 33.374 34.78C33.794 34.5467 34.264 34.43 34.784 34.43C35.304 34.43 35.774 34.5467 36.194 34.78C36.614 35.0067 36.944 35.3333 37.184 35.76C37.4307 36.1867 37.554 36.6833 37.554 37.25C37.554 37.8167 37.4273 38.3167 37.174 38.75C36.9273 39.1767 36.5907 39.5067 36.164 39.74C35.7373 39.9733 35.264 40.09 34.744 40.09ZM34.744 39.29C35.0707 39.29 35.3773 39.2133 35.664 39.06C35.9507 38.9067 36.1807 38.6767 36.354 38.37C36.534 38.0633 36.624 37.69 36.624 37.25C36.624 36.81 36.5373 36.4367 36.364 36.13C36.1907 35.8233 35.964 35.5967 35.684 35.45C35.404 35.2967 35.1007 35.22 34.774 35.22C34.4407 35.22 34.134 35.2967 33.854 35.45C33.5807 35.5967 33.3607 35.8233 33.194 36.13C33.0273 36.4367 32.944 36.81 32.944 37.25C32.944 37.6967 33.024 38.0733 33.184 38.38C33.3507 38.6867 33.5707 38.9167 33.844 39.07C34.1173 39.2167 34.4173 39.29 34.744 39.29ZM39.6605 35.41C39.8205 35.0967 40.0471 34.8533 40.3405 34.68C40.6405 34.5067 41.0038 34.42 41.4305 34.42V35.36H41.1905C40.1705 35.36 39.6605 35.9133 39.6605 37.02V40H38.7505V34.52H39.6605V35.41ZM42.9509 33.63C42.7776 33.63 42.6309 33.57 42.5109 33.45C42.3909 33.33 42.3309 33.1833 42.3309 33.01C42.3309 32.8367 42.3909 32.69 42.5109 32.57C42.6309 32.45 42.7776 32.39 42.9509 32.39C43.1176 32.39 43.2576 32.45 43.3709 32.57C43.4909 32.69 43.5509 32.8367 43.5509 33.01C43.5509 33.1833 43.4909 33.33 43.3709 33.45C43.2576 33.57 43.1176 33.63 42.9509 33.63ZM43.3909 34.52V40H42.4809V34.52H43.3909ZM49.9419 37.05C49.9419 37.2233 49.9319 37.4067 49.9119 37.6H45.5319C45.5652 38.14 45.7485 38.5633 46.0819 38.87C46.4219 39.17 46.8319 39.32 47.3119 39.32C47.7052 39.32 48.0319 39.23 48.2919 39.05C48.5585 38.8633 48.7452 38.6167 48.8519 38.31H49.8319C49.6852 38.8367 49.3919 39.2667 48.9519 39.6C48.5119 39.9267 47.9652 40.09 47.3119 40.09C46.7919 40.09 46.3252 39.9733 45.9119 39.74C45.5052 39.5067 45.1852 39.1767 44.9519 38.75C44.7185 38.3167 44.6019 37.8167 44.6019 37.25C44.6019 36.6833 44.7152 36.1867 44.9419 35.76C45.1685 35.3333 45.4852 35.0067 45.8919 34.78C46.3052 34.5467 46.7785 34.43 47.3119 34.43C47.8319 34.43 48.2919 34.5433 48.6919 34.77C49.0919 34.9967 49.3985 35.31 49.6119 35.71C49.8319 36.1033 49.9419 36.55 49.9419 37.05ZM49.0019 36.86C49.0019 36.5133 48.9252 36.2167 48.7719 35.97C48.6185 35.7167 48.4085 35.5267 48.1419 35.4C47.8819 35.2667 47.5919 35.2 47.2719 35.2C46.8119 35.2 46.4185 35.3467 46.0919 35.64C45.7719 35.9333 45.5885 36.34 45.5419 36.86H49.0019ZM53.083 40.09C52.663 40.09 52.2864 40.02 51.953 39.88C51.6197 39.7333 51.3564 39.5333 51.163 39.28C50.9697 39.02 50.863 38.7233 50.843 38.39H51.783C51.8097 38.6633 51.9364 38.8867 52.163 39.06C52.3964 39.2333 52.6997 39.32 53.073 39.32C53.4197 39.32 53.693 39.2433 53.893 39.09C54.093 38.9367 54.193 38.7433 54.193 38.51C54.193 38.27 54.0864 38.0933 53.873 37.98C53.6597 37.86 53.3297 37.7433 52.883 37.63C52.4764 37.5233 52.143 37.4167 51.883 37.31C51.6297 37.1967 51.4097 37.0333 51.223 36.82C51.043 36.6 50.953 36.3133 50.953 35.96C50.953 35.68 51.0364 35.4233 51.203 35.19C51.3697 34.9567 51.6064 34.7733 51.913 34.64C52.2197 34.5 52.5697 34.43 52.963 34.43C53.5697 34.43 54.0597 34.5833 54.433 34.89C54.8064 35.1967 55.0064 35.6167 55.033 36.15H54.123C54.103 35.8633 53.9864 35.6333 53.773 35.46C53.5664 35.2867 53.2864 35.2 52.933 35.2C52.6064 35.2 52.3464 35.27 52.153 35.41C51.9597 35.55 51.863 35.7333 51.863 35.96C51.863 36.14 51.9197 36.29 52.033 36.41C52.153 36.5233 52.2997 36.6167 52.473 36.69C52.653 36.7567 52.8997 36.8333 53.213 36.92C53.6064 37.0267 53.9264 37.1333 54.173 37.24C54.4197 37.34 54.6297 37.4933 54.803 37.7C54.983 37.9067 55.0764 38.1767 55.083 38.51C55.083 38.81 54.9997 39.08 54.833 39.32C54.6664 39.56 54.4297 39.75 54.123 39.89C53.823 40.0233 53.4764 40.09 53.083 40.09Z"
                    fill="black"
                  />
                </svg>
              </Button>
              <Button className="mobile">
                {/* <Number className="mobile">{wish?.length}</Number> */}
                <Link to={authenticated ? "/profile" : "#"} onClick={(e) => { if (!authenticated) { e.preventDefault(); setIsLogin(true); const dlg = document.getElementById("dialog"); if (dlg && typeof dlg.showModal === "function") { dlg.showModal(); } } }}>
                  <span>
                    <svg
                      width="30"
                      height="41"
                      viewBox="0 0 30 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.43 35.07C5.43 35.65 5.23 36.1333 4.83 36.52C4.43667 36.9 3.83333 37.09 3.02 37.09H1.68V40H0.77V33.03H3.02C3.80667 33.03 4.40333 33.22 4.81 33.6C5.22333 33.98 5.43 34.47 5.43 35.07ZM3.02 36.34C3.52667 36.34 3.9 36.23 4.14 36.01C4.38 35.79 4.5 35.4767 4.5 35.07C4.5 34.21 4.00667 33.78 3.02 33.78H1.68V36.34H3.02ZM7.47102 35.41C7.63102 35.0967 7.85768 34.8533 8.15102 34.68C8.45102 34.5067 8.81435 34.42 9.24102 34.42V35.36H9.00102C7.98102 35.36 7.47102 35.9133 7.47102 37.02V40H6.56102V34.52H7.47102V35.41ZM12.6815 40.09C12.1682 40.09 11.7015 39.9733 11.2815 39.74C10.8682 39.5067 10.5415 39.1767 10.3015 38.75C10.0682 38.3167 9.95148 37.8167 9.95148 37.25C9.95148 36.69 10.0715 36.1967 10.3115 35.77C10.5582 35.3367 10.8915 35.0067 11.3115 34.78C11.7315 34.5467 12.2015 34.43 12.7215 34.43C13.2415 34.43 13.7115 34.5467 14.1315 34.78C14.5515 35.0067 14.8815 35.3333 15.1215 35.76C15.3682 36.1867 15.4915 36.6833 15.4915 37.25C15.4915 37.8167 15.3648 38.3167 15.1115 38.75C14.8648 39.1767 14.5282 39.5067 14.1015 39.74C13.6748 39.9733 13.2015 40.09 12.6815 40.09ZM12.6815 39.29C13.0082 39.29 13.3148 39.2133 13.6015 39.06C13.8882 38.9067 14.1182 38.6767 14.2915 38.37C14.4715 38.0633 14.5615 37.69 14.5615 37.25C14.5615 36.81 14.4748 36.4367 14.3015 36.13C14.1282 35.8233 13.9015 35.5967 13.6215 35.45C13.3415 35.2967 13.0382 35.22 12.7115 35.22C12.3782 35.22 12.0715 35.2967 11.7915 35.45C11.5182 35.5967 11.2982 35.8233 11.1315 36.13C10.9648 36.4367 10.8815 36.81 10.8815 37.25C10.8815 37.6967 10.9615 38.0733 11.1215 38.38C11.2882 38.6867 11.5082 38.9167 11.7815 39.07C12.0548 39.2167 12.3548 39.29 12.6815 39.29ZM18.918 35.27H17.768V40H16.858V35.27H16.148V34.52H16.858V34.13C16.858 33.5167 17.0146 33.07 17.328 32.79C17.648 32.5033 18.158 32.36 18.858 32.36V33.12C18.458 33.12 18.1746 33.2 18.008 33.36C17.848 33.5133 17.768 33.77 17.768 34.13V34.52H18.918V35.27ZM20.449 33.63C20.2757 33.63 20.129 33.57 20.009 33.45C19.889 33.33 19.829 33.1833 19.829 33.01C19.829 32.8367 19.889 32.69 20.009 32.57C20.129 32.45 20.2757 32.39 20.449 32.39C20.6157 32.39 20.7557 32.45 20.869 32.57C20.989 32.69 21.049 32.8367 21.049 33.01C21.049 33.1833 20.989 33.33 20.869 33.45C20.7557 33.57 20.6157 33.63 20.449 33.63ZM20.889 34.52V40H19.979V34.52H20.889ZM23.3499 32.6V40H22.4399V32.6H23.3499ZM29.9009 37.05C29.9009 37.2233 29.8909 37.4067 29.8709 37.6H25.4909C25.5242 38.14 25.7075 38.5633 26.0409 38.87C26.3809 39.17 26.7909 39.32 27.2709 39.32C27.6642 39.32 27.9909 39.23 28.2509 39.05C28.5175 38.8633 28.7042 38.6167 28.8109 38.31H29.7909C29.6442 38.8367 29.3509 39.2667 28.9109 39.6C28.4709 39.9267 27.9242 40.09 27.2709 40.09C26.7509 40.09 26.2842 39.9733 25.8709 39.74C25.4642 39.5067 25.1442 39.1767 24.9109 38.75C24.6775 38.3167 24.5609 37.8167 24.5609 37.25C24.5609 36.6833 24.6742 36.1867 24.9009 35.76C25.1275 35.3333 25.4442 35.0067 25.8509 34.78C26.2642 34.5467 26.7375 34.43 27.2709 34.43C27.7909 34.43 28.2509 34.5433 28.6509 34.77C29.0509 34.9967 29.3575 35.31 29.5709 35.71C29.7909 36.1033 29.9009 36.55 29.9009 37.05ZM28.9609 36.86C28.9609 36.5133 28.8842 36.2167 28.7309 35.97C28.5775 35.7167 28.3675 35.5267 28.1009 35.4C27.8409 35.2667 27.5509 35.2 27.2309 35.2C26.7709 35.2 26.3775 35.3467 26.0509 35.64C25.7309 35.9333 25.5475 36.34 25.5009 36.86H28.9609Z"
                        fill="black"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.26347 13.5931C7.55274 12.6262 9.12085 12.1035 10.7324 12.1035H19.0464C20.9188 12.1035 22.7225 12.8087 24.0984 14.0787L24.3157 14.2793C28.8893 18.5011 26.491 26.1408 20.3252 26.9913L20.198 26.069V27H9.02554V26.069L8.91351 26.9932C2.51785 26.218 0.330477 18.0429 5.48446 14.1774L6.26347 13.5931ZM9.08385 25.1379H20.1317C24.694 24.4607 26.4552 18.7884 23.0527 15.6476L22.8354 15.447C21.8035 14.4944 20.4507 13.9655 19.0464 13.9655H10.7324C9.52375 13.9655 8.34767 14.3575 7.38072 15.0828L6.6017 15.667C2.80466 18.5148 4.39561 24.5255 9.08385 25.1379Z"
                        fill="black"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.1448 9.31033C16.2016 9.31033 17.8689 7.64298 17.8689 5.5862C17.8689 3.52942 16.2016 1.86207 14.1448 1.86207C12.088 1.86207 10.4207 3.52942 10.4207 5.5862C10.4207 7.64298 12.088 9.31033 14.1448 9.31033ZM14.1448 11.1724C17.23 11.1724 19.731 8.67137 19.731 5.5862C19.731 2.50103 17.23 0 14.1448 0C11.0596 0 8.55859 2.50103 8.55859 5.5862C8.55859 8.67137 11.0596 11.1724 14.1448 11.1724Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </Link>
              </Button>
              <Button className="mobile">
                <Number className="mobile">{cartData?.length}</Number>
                <Link to={authenticated ? "/wishlist" : "#"} onClick={(e) => { if (!authenticated) { e.preventDefault(); setIsLogin(true); const dlg = document.getElementById("dialog"); if (dlg && typeof dlg.showModal === "function") { dlg.showModal(); } } }}>
                  {/* <Link to={authenticated ? "/wishlist" : "/login"}> */}
                  <span>
                    <svg
                      width="29"
                      height="41"
                      viewBox="0 0 29 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.0161 3C1.74661 3 1.48816 3.10705 1.29761 3.29761C1.10705 3.48816 1 3.74661 1 4.0161C1 4.28558 1.10705 4.54403 1.29761 4.73459C1.48816 4.92514 1.74661 5.0322 2.0161 5.0322H2.51602C2.73666 5.03258 2.95118 5.10477 3.12716 5.23785C3.30314 5.37094 3.43102 5.55769 3.49147 5.76988L6.71454 17.0486C6.89683 17.6851 7.2814 18.2449 7.8101 18.6435C8.3388 19.042 8.98288 19.2576 9.64497 19.2576H18.9301C19.5394 19.2577 20.1348 19.0752 20.6394 18.7336C21.144 18.392 21.5347 17.907 21.7609 17.3412L24.7564 9.85054C24.8795 9.5423 24.9253 9.2086 24.8897 8.8786C24.8541 8.54859 24.7382 8.23233 24.5521 7.95746C24.3661 7.68259 24.1155 7.45747 23.8224 7.30179C23.5292 7.14611 23.2024 7.0646 22.8705 7.06439H5.97482L5.44441 5.21103C5.26258 4.57449 4.87848 4.01444 4.35016 3.61555C3.82184 3.21665 3.17802 3.00058 2.51602 3H2.0161ZM8.66951 16.4877L6.55603 9.09659H22.8705L19.873 16.5873C19.7975 16.7756 19.6674 16.9371 19.4993 17.0508C19.3313 17.1645 19.133 17.2253 18.9301 17.2254H9.64497C9.42433 17.225 9.20981 17.1528 9.03383 17.0197C8.85785 16.8866 8.72997 16.6999 8.66951 16.4877ZM10.1449 27.3864C10.5452 27.3864 10.9416 27.3075 11.3114 27.1543C11.6813 27.0011 12.0173 26.7766 12.3004 26.4935C12.5834 26.2105 12.808 25.8744 12.9611 25.5046C13.1143 25.1348 13.1932 24.7384 13.1932 24.3381C13.1932 23.9378 13.1143 23.5414 12.9611 23.1715C12.808 22.8017 12.5834 22.4657 12.3004 22.1826C12.0173 21.8995 11.6813 21.675 11.3114 21.5218C10.9416 21.3686 10.5452 21.2898 10.1449 21.2898C9.33643 21.2898 8.56108 21.6109 7.98941 22.1826C7.41775 22.7543 7.09659 23.5296 7.09659 24.3381C7.09659 25.1465 7.41775 25.9219 7.98941 26.4935C8.56108 27.0652 9.33643 27.3864 10.1449 27.3864ZM10.1449 25.3542C9.8754 25.3542 9.61695 25.2471 9.4264 25.0566C9.23584 24.866 9.12879 24.6076 9.12879 24.3381C9.12879 24.0686 9.23584 23.8101 9.4264 23.6196C9.61695 23.429 9.8754 23.322 10.1449 23.322C10.4144 23.322 10.6728 23.429 10.8634 23.6196C11.0539 23.8101 11.161 24.0686 11.161 24.3381C11.161 24.6076 11.0539 24.866 10.8634 25.0566C10.6728 25.2471 10.4144 25.3542 10.1449 25.3542ZM18.2737 27.3864C18.674 27.3864 19.0704 27.3075 19.4402 27.1543C19.81 27.0011 20.1461 26.7766 20.4291 26.4935C20.7122 26.2105 20.9367 25.8744 21.0899 25.5046C21.2431 25.1348 21.322 24.7384 21.322 24.3381C21.322 23.9378 21.2431 23.5414 21.0899 23.1715C20.9367 22.8017 20.7122 22.4657 20.4291 22.1826C20.1461 21.8995 19.81 21.675 19.4402 21.5218C19.0704 21.3686 18.674 21.2898 18.2737 21.2898C17.4652 21.2898 16.6899 21.6109 16.1182 22.1826C15.5465 22.7543 15.2254 23.5296 15.2254 24.3381C15.2254 25.1465 15.5465 25.9219 16.1182 26.4935C16.6899 27.0652 17.4652 27.3864 18.2737 27.3864ZM18.2737 25.3542C18.0042 25.3542 17.7457 25.2471 17.5552 25.0566C17.3646 24.866 17.2576 24.6076 17.2576 24.3381C17.2576 24.0686 17.3646 23.8101 17.5552 23.6196C17.7457 23.429 18.0042 23.322 18.2737 23.322C18.5432 23.322 18.8016 23.429 18.9922 23.6196C19.1827 23.8101 19.2898 24.0686 19.2898 24.3381C19.2898 24.6076 19.1827 24.866 18.9922 25.0566C18.8016 25.2471 18.5432 25.3542 18.2737 25.3542Z"
                        fill="black"
                      />
                      <path
                        d="M3.93 36.51C3.93 35.83 4.08333 35.22 4.39 34.68C4.69667 34.1333 5.11333 33.7067 5.64 33.4C6.17333 33.0933 6.76333 32.94 7.41 32.94C8.17 32.94 8.83333 33.1233 9.4 33.49C9.96667 33.8567 10.38 34.3767 10.64 35.05H9.55C9.35667 34.63 9.07667 34.3067 8.71 34.08C8.35 33.8533 7.91667 33.74 7.41 33.74C6.92333 33.74 6.48667 33.8533 6.1 34.08C5.71333 34.3067 5.41 34.63 5.19 35.05C4.97 35.4633 4.86 35.95 4.86 36.51C4.86 37.0633 4.97 37.55 5.19 37.97C5.41 38.3833 5.71333 38.7033 6.1 38.93C6.48667 39.1567 6.92333 39.27 7.41 39.27C7.91667 39.27 8.35 39.16 8.71 38.94C9.07667 38.7133 9.35667 38.39 9.55 37.97H10.64C10.38 38.6367 9.96667 39.1533 9.4 39.52C8.83333 39.88 8.17 40.06 7.41 40.06C6.76333 40.06 6.17333 39.91 5.64 39.61C5.11333 39.3033 4.69667 38.88 4.39 38.34C4.08333 37.8 3.93 37.19 3.93 36.51ZM11.6546 37.24C11.6546 36.68 11.7679 36.19 11.9946 35.77C12.2213 35.3433 12.5313 35.0133 12.9246 34.78C13.3246 34.5467 13.7679 34.43 14.2546 34.43C14.7346 34.43 15.1513 34.5333 15.5046 34.74C15.8579 34.9467 16.1213 35.2067 16.2946 35.52V34.52H17.2146V40H16.2946V38.98C16.1146 39.3 15.8446 39.5667 15.4846 39.78C15.1313 39.9867 14.7179 40.09 14.2446 40.09C13.7579 40.09 13.3179 39.97 12.9246 39.73C12.5313 39.49 12.2213 39.1533 11.9946 38.72C11.7679 38.2867 11.6546 37.7933 11.6546 37.24ZM16.2946 37.25C16.2946 36.8367 16.2113 36.4767 16.0446 36.17C15.8779 35.8633 15.6513 35.63 15.3646 35.47C15.0846 35.3033 14.7746 35.22 14.4346 35.22C14.0946 35.22 13.7846 35.3 13.5046 35.46C13.2246 35.62 13.0013 35.8533 12.8346 36.16C12.6679 36.4667 12.5846 36.8267 12.5846 37.24C12.5846 37.66 12.6679 38.0267 12.8346 38.34C13.0013 38.6467 13.2246 38.8833 13.5046 39.05C13.7846 39.21 14.0946 39.29 14.4346 39.29C14.7746 39.29 15.0846 39.21 15.3646 39.05C15.6513 38.8833 15.8779 38.6467 16.0446 38.34C16.2113 38.0267 16.2946 37.6633 16.2946 37.25ZM19.6624 35.41C19.8224 35.0967 20.0491 34.8533 20.3424 34.68C20.6424 34.5067 21.0058 34.42 21.4324 34.42V35.36H21.1924C20.1724 35.36 19.6624 35.9133 19.6624 37.02V40H18.7524V34.52H19.6624V35.41ZM23.5929 35.27V38.5C23.5929 38.7667 23.6496 38.9567 23.7629 39.07C23.8762 39.1767 24.0729 39.23 24.3529 39.23H25.0229V40H24.2029C23.6962 40 23.3162 39.8833 23.0629 39.65C22.8096 39.4167 22.6829 39.0333 22.6829 38.5V35.27H21.9729V34.52H22.6829V33.14H23.5929V34.52H25.0229V35.27H23.5929Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                </Link>
              </Button>

              <CategoriesModal className={isCategoriesVisible ? "active" : ""}>
                <Items className="mobile">
                  {data.slice(0, -1).map((item, i) => (
                    <Item
                      // style={{
                      //   backgroundColor:
                      //     selectedCategory === item.category_id && subcategory
                      //       ? "#e1f0da"
                      //       : "transparent",
                      // }}
                      key={i}
                      // onMouseEnter={() => handleSubCategory(item.category_id)}
                      // onClick={() => setSubcategory(false)}
                      onClick={() => {
                        handleCategoryMain(item.category_slug);
                      }}
                    >
                      <ItemDiv>
                        <>
                          <div>
                            <img
                              src={categoryurl + item.logo}
                              width={30}
                              height={30}
                            />{" "}
                          </div>
                          <div>{item.category_name}</div>
                        </>
                        {/* <Arrow>
                          <BsChevronDown />
                        </Arrow> */}
                      </ItemDiv>
                    </Item>
                  ))}
                </Items>
              </CategoriesModal>
            </Buttons>
          </MobileHeaderBottom>
          <MobileHeaderBottomBackground></MobileHeaderBottomBackground>
          <el-dialog>
            <dialog
              id="dialog"
              aria-labelledby="dialog-title"
              class="fixed inset-0 size-auto max-h-none max-w-none overflow-y-auto bg-transparent backdrop:bg-transparent lg:mt-0 mt-[40%] md:mt-[25%]"
            >
              <el-dialog-backdrop class="fixed inset-0 bg-[#62BC01] lg:bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"></el-dialog-backdrop>

              <div
                tabindex="0"
                class="flex min-h-[400px] lg:min-h-full items-end justify-center p-0 lg:p-4 text-center focus:outline-none sm:items-center sm:p-0 mt-0 md:mt-0 sm:mt-50"
              >
                <el-dialog-panel class="relative transform overflow-hidden lg:rounded-[54px] w-[100vw] lg:w-[max-content] rounded-[24px] bg-white text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 data-closed:sm:translate-y-0 data-closed:sm:scale-95">
                  {isLogin ? <Login /> : <Registration />}
                </el-dialog-panel>
                {/* </el-dialog-panel> */}
              </div>
            </dialog>
          </el-dialog>
        </>
      )}
    </>
  );
}

export default HeaderMainNew;
const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  @media screen and (max-width: 1080px) {
    display: none;
  }
`;
const Container = styled.div`
  display: grid;
  grid-template-columns: 0.2fr 1.8fr 0.5fr;
  gap: 20px;
  align-items: center;
`;
const Top = styled.div`
  padding: 16px 40px;
  background-color: #084c27;
  display: flex;
  align-items: center;
  justify-content: space-betnwee;
`;
const Left = styled.div``;
const Right = styled.div`
  a {
    background-color: #fff;
    color: #084c27;
    font-weight: 600;
    border-radius: 50px;
    padding: 10px 20px;
    font-size: 14px;
    font-family: "Jost", serif;
  }
`;
const Socials = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  a {
    flex-shrink: 0;

    background-color: #fff;

    border-radius: 50%;
    padding: 4px;
  }
  svg {
    color: #084c27;
    font-size: 15px;
  }

  /* mobile */
  &.mobile {
    justify-content: center;
    margin: 0 auto;
    a {
      background-color: transparent;
    }
    svg {
      font-size: 33px;
      padding: 5px;
      background-color: #084c27;
      color: #fff;
      border-radius: 10px;
    }
  }
`;
const Main = styled.div`
  background-color: #fff;
`;
const Section = styled.section`
  justify-self: end;
  /* .top-btns {
    @media screen and (max-width: 1080px) {
      display: none;
    }
  } */
`;
const ImageContainer = styled.div`
  height: 70px;
  width: 125px;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    display: block;
  }
  @media screen and (max-width: 540px) {
    height: 60px;
    width: 115px;
  }
`;
const Nav = styled.nav`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-self: center;
  justify-content: center;
  width: 100%;
  a {
    font-family: "Jost", serif;
    font-weight: 500;
    color: #000000;
    font-size: 18px;

    &:hover {
      // transition: all 0.3s ease;
      // font-size: 20px;
      // font-weight: 500;
      color: #084c27;
    }
  }

  /* mobile */
  &.mobile {
    display: grid;
    justify-content: start;
    a {
      width: 100%;
      margin-bottom: 10px;
      padding-bottom: 5px;
      /* border-bottom: 1px solid #9c9c9c; */
    }
  }
`;
const NavInner = styled.div`
  display: flex;
  gap: 35px;
  align-items: center;
  padding-left: 50px;

  a {
    font-family: "Jost", sans-serif;
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;
    color: #000000;

    @media (max-width: 1300px) {
      font-size: 15px;
    }
  }
`;
const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  background: #f3f3f3;
  padding: 5px 15px;
  margin-left: 20px;
  width: 35%;
  @media screen and (max-width: 1080px) {
    width: 100%;
  }
  @media screen and (max-width: 540px) {
    margin-left: 0px;
  }
`;
const SearchContainerOld = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #9c9c9c;
  border-radius: 7px;
  background: #f3f3f3;
  padding: 5px 15px;
  margin-left: 20px;
  width: 35%;
  @media screen and (max-width: 1080px) {
    width: 100%;
  }
  @media screen and (max-width: 540px) {
    margin-left: 0px;
  }
`;
const SearchSuggestions = styled.ul`
  position: absolute;
  top: 62%;
  left: 58%;
  transform: translateX(-50%);
  z-index: 100;
  list-style: none;
  margin: 0;
  padding: 8px;
  background: #ffffff;
  border: 1px solid #eef1f4;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.12);
  min-width: 320px;
  max-width: 520px;
  max-height: 360px;
  overflow-y: auto;
  backdrop-filter: saturate(180%) blur(8px);

  /* Hide scrollbar scroller (keep scroll functional) */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar { width: 0; height: 0; } /* Chrome/Safari */
  &::-webkit-scrollbar-thumb { background: transparent; }
  &::-webkit-scrollbar-track { background: transparent; }

  &.mobile {
    top: 80%;
    left: 80%;
    width: 35%;
    @media screen and (max-width: 540px) {
      top: 100%;
      left: 52%;
      width: 90%;
    }
  }

  &.mobile-drop {
    top: 103%;
    left: 50%;
    width: 100%;
    max-height: 300px;
  }
`;
const Suggestion = styled.li`
  margin-left: 0;
  border-radius: 10px;
  color: #111827;
  font-size: 14px;
  cursor: pointer;
  padding: 10px 12px;
  transition: background 0.15s ease, color 0.15s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #f9fafb;
    color: #0f172a;
  }

  & + li { margin-top: 4px; }
`;
const Input = styled.input`
  border: none;
  font-family: "Jost", serif;
  background: #f3f3f3;
  outline: none;
  &::placeholder {
    color: #9c9c9c;
    font-family: "Jost", serif;
  }
  &:focus {
    outline: none;
    border: none;
  }
  &.mobile-search {
    padding: 0;
    &::placeholder {
      padding-left: 0;
      padding-bottom: 0;
    }
  }
`;
const Buttons = styled.div`
  display: flex;
  align-items: end;
  gap: 25px;

  &.mobile {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: center;
    margin: 40px 0;
    button {
      padding: 8px 20px;
      border: 2px solid #084c27;
      border-radius: 8px;
      background-color: transparent;
    }
  }

  &.bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;
const LoginBtn = styled.button`
  border: 2px solid #084c27;
  border-radius: 5px;
  color: #084c27;
  padding: 5px 20px;
  background-color: transparent;
  font-family: "Jost", serif;
  font-size: 18px;
`;
const Button = styled.button`
  display: grid;
  justify-items: start;
  flex-shrink: 0;
  border: none;
  outline: none;
  background-color: transparent;
  a {
    font-family: "Jost", serif;
    color: #000;
    &:hover {
      transition: all 0.3s ease;
      font-size: 16px;
      font-weight: 500;
    }
  }
  svg {
    font-size: 20px;
  }

  &.notification-style {
    position: relative;
  }
  &.user {
    display: flex;
    align-items: center;
    /* justify-items: center;
    font-size: 13px; */
  }

  /* mobile */
  &.mobile {
    position: relative;
  }
`;
const Number = styled.p`
  height: 22px;
  width: 22px;
  border-radius: 50%;
  background-color: #ff0000;
  color: #fff;
  font-weight: 400;
  font-size: 13px;
  font-family: "Jost", serif;
  display: grid;
  place-items: center;
  position: absolute;
  left: -10px;
  top: -10px;
  margin-bottom: 0;
  /* mobile */
  &.mobile {
    position: absolute;
    right: -10px;
    top: -10px;
    height: unset;
    width: unset;
    height: 22px;
    width: 22px;
    font-size: 13px;
    margin-bottom: 0;
  }
`;
// mobile

const MobileHeader = styled.div`
  display: none;
  @media screen and (max-width: 1080px) {
    background-color: #fff;
    padding: 10px 40px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  }
  @media screen and (max-width: 540px) {
    grid-template-columns: 0.2fr 0.5fr 1.3fr;
    padding: 20px;
    gap: 30px;
  }
`;
const MobileHeaderBottom = styled.div`
  display: none;
  @media screen and (max-width: 1080px) {
    background-color: #fff;
    padding: 16px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 10px;
    left: 0;
    width: 100%;
    z-index: 10;
    border: 3px solid #187837;
    border-radius: 28px;
    justify-self: anchor-center;
    width: 90%;
    margin: 0 auto;
    // margin-left: 10px;
  }
`;

const MobileHeaderSearch = styled.div`
  display: none;
  @media screen and (max-width: 1080px) {
    background-color: #fff;
    padding: 10px 40px;
    display: grid;
    grid-template-columns: 1fr;

    align-items: center;
    position: fixed;
    top: 70px;
    left: 0;
    width: 100%;
    z-index: 10;
  }
  @media screen and (max-width: 540px) {
    // grid-template-columns: 0.2fr 0.5fr 1.3fr;
    padding: 20px;
    gap: 30px;
  }
`;
const MobileHeaderBottomBackground = styled.div`
  display: none;
  @media screen and (max-width: 1080px) {
    background-color: #fff;
    padding: 20px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: -33px;
    left: 0;
    z-index: 5;
    background: #187837;
    border-radius: 28px;
    justify-self: anchor-center;
    width: 92%;
    margin: 0 auto;
  }
`;
const Slider = styled.div`
  position: fixed;
  left: -100%;
  top: 0;
  padding: 10px 20px;
  height: 100%;
  background-color: #f8f8f8;
  transition: all 0.5s linear;
  z-index: 11;
  &.active {
    left: 0;
  }
`;
const MobileTop = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.1fr;
  gap: 20px;
  align-items: center;

  svg {
    font-size: 20px;
    background-color: #d5dded;
    padding: 5px;
    border-radius: 50%;
  }
`;
const P = styled.p`
  font-family: "Jost", serif;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`;
const ItemContainer = styled.div`
  padding: 10px 0;
  background-color: #f4f4f4;
`;
const Items = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  &.mobile {
    flex-direction: column;
  }
`;
const Dropdown = styled.div`
  z-index: 99;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(100% - 0px);
  border-radius: 10px;

  box-shadow: 1px 1px 14px #4242426f;
  background-color: #fff;
  padding: 10px;

  transition: all 0.3s ease;
  display: none;
  /* opacity: 0; */

  li {
    font-size: 15px;
    color: #000;
    min-width: max-content;
    list-style-type: none;
    padding: 8px 10px;
    cursor: pointer;
    &:hover {
      color: #fc9800;
    }
  }
`;
const Item = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  transform: all 0.5s ease;

  &:hover ${Dropdown} {
    display: grid;
    /* opacity: 1; */
  }
`;
const Icon = styled.div``;
const Text = styled.p`
  font-size: 16px;
  color: #000;
  font-family: "Jost", serif;
`;
const Arrow = styled.div`
  svg {
    font-size: 16px;
    color: #000;
  }
`;
const LoginButton = styled.div`
  font-size: 20px;
  text-transform: capitalize;
`;
const ItemDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;
const LogoutModal = styled.div`
  position: absolute;
  right: 75px;
  top: 72px;
  z-index: 1;
  display: ${(props) => (props.open ? "block" : "none")};
`;

const LogoutModalMobileSec = styled.div`
  position: absolute;
  right: 20px;
  top: 147px;
  z-index: 20;
  display: ${(props) => (props.open ? "block" : "none")};
`;

const LogoutModalMobile = styled.div`
  position: absolute;
  right: -100%;
  bottom: 62px;
  z-index: 2;
  background-color: #fff;
  padding: 10px;
  transition: 0.3s ease;
  &.active {
    right: 0px;
  }

  button {
    margin-bottom: 0;
  }
  display: grid;
  gap: 20px;
`;
const CategoriesModal = styled.div`
  position: absolute;
  bottom: -800%;
  left: 0;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  transition: all 0.4s ease;
  &.active {
    bottom: 62px;
  }
`;
const DropSearch = styled.div`
  display: none;
  @media screen and (max-width: 540px) {
    display: block;
    justify-self: end;
  }
`;
const MobileSearch = styled.div`
  @media screen and (max-width: 540px) {
    border-radius: 10px;
    background-color: #fff;
    justify-self: end;
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
  }
`;
